"use strict";
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createAddress(containerEl, deps) {
                const { formDeps, getAddress, isNew, disableDefaultAddress, countryChangeEnabled } = deps;
                const popupEl = eXpress.html.querySelector(document, '.p-my-account-address', true);
                const popupFormEl = eXpress.html.querySelector(document, '.technical-address-form', true);
                const buttonContainerEl = eXpress.html.querySelector(popupEl, '.technical-address-button-container', true);
                const saveDeliveryAddressButtonEl = eXpress.html.querySelector(buttonContainerEl, '.technical-save-address-button', true);
                const addressForm = checkout.createPersonalDataForm(eXpress.html.querySelector(containerEl, '.technical-address-form', true), {
                    onSubmit: formDeps.onSubmit,
                    getZipCodeDefinitionAsync: formDeps.getZipCodeDefinitionAsync,
                    getCitiesForCountryCodeAndSearchTerm: formDeps.getCitiesForCountryCodeAndSearchTerm,
                    getGetCitiesByZipCode: formDeps.getGetCitiesByZipCode,
                    alternativeSubmitButtonEl: saveDeliveryAddressButtonEl
                });
                // load the address , instead of reloading the popup each time it opens
                if (!isNew) {
                    eXpress.utils.showLoadingDialog(getAddress().then(res => addressForm.fillFormData(res, disableDefaultAddress, countryChangeEnabled)));
                }
                // update with default country, should never be undefined
                const isCompanyEl = eXpress.html.querySelector(popupEl, '.technical-company', false);
                const isCompany = isCompanyEl && isCompanyEl.checked;
                const overrideDefaultRegions = popupFormEl.dataset.defaultRegions || '';
                addressForm.updateCountry(containerEl.dataset.defaultRegion, isCompany, false, overrideDefaultRegions);
                return {
                    setErrors: addressForm.setErrors,
                    dispose: addressForm.dispose,
                };
            }
            checkout.createAddress = createAddress;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createAdyenDropIn(containerEl, deps) {
                return __awaiter(this, void 0, void 0, function* () {
                    const locale = containerEl.dataset.locale || "";
                    const clientKey = containerEl.dataset.clientkey || "";
                    const countryCode = containerEl.dataset.countrycode || "";
                    const currency = containerEl.dataset.currency || "";
                    const amount = containerEl.dataset.amount || "";
                    const refreshMiniBasket = containerEl.dataset.refreshminibasket === "true";
                    const environment = containerEl.dataset.isproduction === "true" ? "live" : "test";
                    const enableStoreDetails = containerEl.dataset.enablestoredetails === "true";
                    const placeOrderContainerEl = eXpress.html.querySelector(document, ".technical-place-order-checkout-step", true);
                    const resetButtonEl = eXpress.html.querySelector(placeOrderContainerEl, ".technical-reset", true);
                    const loadingEl = eXpress.html.querySelector(document, '.adyen-loading', false);
                    let obKlarna = undefined;
                    const eventDisposables = eXpress.utils.compositeDisposable([]);
                    const { AdyenCheckout, Dropin } = window.AdyenWeb;
                    let adyenDropInComponent;
                    let adyenCheckoutObject;
                    let configuration;
                    let dropInOpts;
                    let selectedPaymentBrand;
                    let forceNewOrder = false;
                    const reason = eXpress.utils.getParameter('reason', document.location.href, false);
                    const selectedClass = "adyen-checkout__payment-method--selected";
                    const nextSelectedClass = "adyen-checkout__payment-method--next-selected";
                    const paymentMethodClass = "adyen-checkout__payment-method";
                    const buttonSelector = ".adyen-checkout__button";
                    const paymentMethodSelector = ".adyen-checkout__payment-method";
                    const paymentMethodHeaderTitleSelector = ".adyen-checkout__payment-method__header__title";
                    if (reason && reason.toLowerCase() === 'refused') {
                        forceNewOrder = true;
                    }
                    const { getTestOrderOptionValue, getPaymentMethods, validate, initiatePayment, submitAdditionalDetails, placeOfflineOrder, newsletterEl, personalMessageEl, testOrderOptionEl, updateCartHandlingCost, disableStoredPaymentMethod, fetchRecaptchaToken, recaptchaEnabled } = deps;
                    const onBankTransferSubmit = (e) => {
                        e.preventDefault();
                        if (validate()) {
                            toggleDisableAllButtonStates(true);
                            toggleDisableButtonState(resetButtonEl, true, false);
                            const bankTransferEl = eXpress.html.querySelector(containerEl, '.technical-bank-transfer', true);
                            const printPaymentFormEl = eXpress.html.querySelector(bankTransferEl, "#printPaymentForm", false);
                            placeOfflineOrder(newsletterEl.checked, personalMessageEl.checked, printPaymentFormEl && printPaymentFormEl.checked || false, selectedPaymentBrand, getTestOrderOptionValue(testOrderOptionEl));
                        }
                    };
                    const deselectPaymentMethod = () => {
                        // This does our own method
                        const bankTransferEl = eXpress.html.querySelector(containerEl, '.technical-bank-transfer', false);
                        if (bankTransferEl) {
                            bankTransferEl.classList.remove(selectedClass);
                            bankTransferEl.classList.remove(nextSelectedClass);
                            // Add deselected states of clicked tab
                            const paymentHeaderTitle = eXpress.html.querySelector(bankTransferEl, paymentMethodHeaderTitleSelector, true);
                            paymentHeaderTitle.setAttribute("aria-checked", "false");
                            paymentHeaderTitle.setAttribute("aria-expanded", "false");
                            const paymentMethodDetailsEl = eXpress.html.querySelector(bankTransferEl, '.adyen-checkout-pm-details-wrapper', true);
                            paymentMethodDetailsEl.setAttribute("aria-hidden", "true");
                        }
                    };
                    const onBankTransferClick = (ev) => {
                        selectedPaymentBrand = "banktransfer";
                        toggleDisableAllButtonStates(false);
                        toggleDisableButtonState(resetButtonEl, false, false);
                        refreshMiniBasket && updateCartHandlingCost(0, 1);
                        const currentEl = ev.currentTarget;
                        const bankTransferEl = eXpress.html.getParentOrSelfWithClassName(currentEl, "technical-bank-transfer");
                        if (bankTransferEl) {
                            if (eXpress.html.hasClass(bankTransferEl, selectedClass))
                                return;
                            // This method deselects all the adyen methods
                            adyenDropInComponent.closeActivePaymentMethod();
                            // Add selected states of clicked tab
                            const paymentHeaderTitle = eXpress.html.querySelector(bankTransferEl, paymentMethodHeaderTitleSelector, true);
                            paymentHeaderTitle.setAttribute("aria-checked", "true");
                            paymentHeaderTitle.setAttribute("aria-expanded", "true");
                            const paymentMethodDetailsEl = eXpress.html.querySelector(bankTransferEl, '.adyen-checkout-pm-details-wrapper', true);
                            paymentMethodDetailsEl.setAttribute("aria-hidden", "false");
                            bankTransferEl.classList.add(selectedClass);
                            let previousPaymentMethodLi = bankTransferEl.previousElementSibling;
                            if (previousPaymentMethodLi) {
                                previousPaymentMethodLi = previousPaymentMethodLi.previousElementSibling;
                                previousPaymentMethodLi && previousPaymentMethodLi.classList.add(nextSelectedClass);
                            }
                        }
                    };
                    const injectCustomInvoiceMethod = (templatesEl) => {
                        const template = templatesEl.children[0];
                        let divEl = document.createElement("div");
                        template.classList.forEach(c => { divEl.classList.add(c); });
                        divEl.classList.add("technical-bank-transfer");
                        divEl.innerHTML = template.innerHTML;
                        if (containerEl) {
                            const paymentList = eXpress.html.querySelector(containerEl, ".adyen-checkout__payment-methods-list--otherPayments", false);
                            if (paymentList) {
                                const existingListEl = eXpress.html.querySelector(paymentList, ".technical-bank-transfer", false);
                                if (!existingListEl) {
                                    paymentList.insertAdjacentElement("beforeend", divEl);
                                    divEl = eXpress.html.querySelector(paymentList, ".technical-bank-transfer", true);
                                    const bankTransferTitleEl = eXpress.html.querySelector(divEl, ".adyen-checkout__payment-method__header", true);
                                    const bankTransferButtonEl = eXpress.html.querySelector(divEl, ".technical-submit-bank-transfer", true);
                                    if (eventDisposables && eventDisposables.add) {
                                        eventDisposables.add([
                                            eXpress.html.addEventListener(bankTransferTitleEl, "click", onBankTransferClick),
                                            eXpress.html.addEventListener(bankTransferButtonEl, "click", onBankTransferSubmit)
                                        ]);
                                    }
                                }
                            }
                        }
                    };
                    const injectKlarnaAdditionalFeeMessage = (listEl, description, feeMessage) => {
                        const contentEl = eXpress.html.querySelector(listEl, ".adyen-checkout__payment-method__details__content", false);
                        if (contentEl) {
                            const buttonEl = eXpress.html.querySelector(contentEl, buttonSelector, false);
                            if (buttonEl) {
                                const remarkEl = eXpress.html.querySelector(contentEl, ".m-adyen-drop-in__remarks", false);
                                if (!remarkEl && obKlarna) {
                                    obKlarna.disconnect();
                                    const remarksDiv = document.createElement("div");
                                    remarksDiv.classList.add("m-adyen-drop-in__remarks");
                                    const feeMessageEl = document.createElement("p");
                                    feeMessageEl.innerHTML = feeMessage;
                                    feeMessageEl.classList.add("a-typography--remarks");
                                    const descriptionEl = document.createElement("p");
                                    descriptionEl.innerHTML = description;
                                    descriptionEl.classList.add("m-adyen-drop-in__description");
                                    remarksDiv.append(descriptionEl);
                                    remarksDiv.append(feeMessageEl);
                                    if (contentEl.parentElement)
                                        contentEl.parentElement.insertBefore(remarksDiv, contentEl);
                                    buttonEl.classList.remove("adyen-checkout__button--standalone");
                                }
                            }
                        }
                    };
                    const injectSwishMessage = (message) => {
                        const swishDropin = eXpress.html.querySelector(document, ".technical-dropin-container");
                        if (swishDropin) {
                            const msgEl = eXpress.html.querySelector(swishDropin, ".adyen-checkout__qr-loader__subtitle", false);
                            if (msgEl) {
                                const remarksDiv = document.createElement("div");
                                remarksDiv.classList.add("m-adyen-drop-in__remarks");
                                const messageEl = document.createElement("p");
                                messageEl.innerHTML = message;
                                messageEl.classList.add("a-typography--remarks");
                                remarksDiv.append(messageEl);
                                if (msgEl.parentElement)
                                    msgEl.parentElement.insertBefore(remarksDiv, msgEl);
                            }
                            else
                                setTimeout(function () { injectSwishMessage(message); }, 100);
                        }
                        else
                            setTimeout(function () { injectSwishMessage(message); }, 100);
                    };
                    const toggleSelectedPaymentMethodState = (el, select) => {
                        if (el)
                            el.classList.toggle(selectedClass, select);
                    };
                    const toggleDisableAllButtonStates = (disable) => {
                        const buttonEls = eXpress.html.querySelectorAll(document, buttonSelector);
                        buttonEls.forEach((buttonEl) => {
                            toggleDisableButtonState(buttonEl, disable);
                        });
                        const els = eXpress.html.querySelectorAll(document, paymentMethodSelector);
                        els.forEach((el) => { toggleSelectedPaymentMethodState(el, false); });
                    };
                    const toggleDisableButtonState = (buttonEl, disable, changeAttribute = true) => {
                        if (disable) {
                            buttonEl.classList.add("a-button--disabled");
                            if (changeAttribute)
                                buttonEl.setAttribute("disabled", "true");
                        }
                        else {
                            buttonEl.classList.remove("a-button--disabled");
                            if (changeAttribute)
                                buttonEl.removeAttribute("disabled");
                        }
                    };
                    const injectExtraPaymentMethods = () => {
                        if (placeOrderContainerEl) {
                            const templatesEl = eXpress.html.querySelector(placeOrderContainerEl, ".technical-banktransfer-templates", false);
                            if (templatesEl)
                                injectCustomInvoiceMethod(templatesEl);
                        }
                    };
                    const onBrand = (callBack) => {
                        if (callBack && callBack.brand) {
                            selectedPaymentBrand = callBack.brand;
                        }
                    };
                    const onAdyenError = (error) => {
                        if (error.name !== 'CANCEL')
                            return;
                        // reset => when canceling payment you could not select that payment method anymore before selecting an other payment method
                        adyenDropInComponent.closeActivePaymentMethod();
                        deselectPaymentMethod();
                    };
                    const onPaymentMethodsRequest = (_data, actions) => __awaiter(this, void 0, void 0, function* () {
                        const paymentMethods = getPaymentMethods();
                        actions.resolve(paymentMethods);
                    });
                    const onAdditionalDetails = (state, component, actions) => {
                        submitAdditionalDetails(state.data, component, actions);
                    };
                    const onDisableStoredPaymentMethod = (storedPaymentMethodId, resolve, reject) => {
                        disableStoredPaymentMethod({ RecurringDetailReference: storedPaymentMethodId }).then(res => {
                            if (res.redirectUrl)
                                window.location.href = res.redirectUrl;
                            if (res.success) {
                                resolve();
                                toggleDisableButtonState(resetButtonEl, true, false);
                            }
                            else
                                reject();
                        });
                    };
                    const init = () => __awaiter(this, void 0, void 0, function* () {
                        getPaymentMethods().then((res) => __awaiter(this, void 0, void 0, function* () {
                            let translations = {};
                            if (loadingEl)
                                eXpress.html.hide(loadingEl);
                            if (res.translations)
                                translations = res.translations;
                            if (res.redirectUrl) {
                                window.location.href = res.redirectUrl;
                            }
                            else {
                                configuration = {
                                    paymentMethodsResponse: res,
                                    clientKey: clientKey,
                                    locale: locale,
                                    translations: translations,
                                    environment: environment,
                                    showPayButton: true,
                                    countryCode: countryCode,
                                    onError: onAdyenError,
                                    onPaymentMethodsRequest,
                                    onSubmit: (state, component, actions) => {
                                        const submit = (token) => {
                                            const swishAppNotAvailable = containerEl.dataset.swishappnotavailable || "";
                                            if (state.isValid && validate()) {
                                                toggleDisableAllButtonStates(true);
                                                const data = {
                                                    Newsletter: newsletterEl.checked,
                                                    PersonalMessage: personalMessageEl.checked,
                                                    ForceNewOrder: forceNewOrder,
                                                    PaymentRequest: state.data,
                                                    Token: token || '',
                                                    TestOrderOption: getTestOrderOptionValue(testOrderOptionEl),
                                                    PaymentBrand: state.data.paymentMethod && state.data.paymentMethod.brand ? state.data.paymentMethod.brand : selectedPaymentBrand,
                                                    PaymentName: state.data.paymentMethod.storedPaymentMethodId && state.data.paymentMethod.storedPaymentMethodId !== ''
                                                        ? 'storedcard'
                                                        : res.paymentMethods && res.paymentMethods.find(p => p.type === (state.data.paymentMethod.type === "scheme" && selectedPaymentBrand === "bcmc"
                                                            ? selectedPaymentBrand
                                                            : state.data.paymentMethod.type)).name || '',
                                                    SupportedShopperInteractions: res.storedPaymentMethods && state.data.paymentMethod.storedPaymentMethodId && state.data.paymentMethod.storedPaymentMethodId !== ''
                                                        ? res.storedPaymentMethods.find(s => s.id === state.data.paymentMethod.storedPaymentMethodId).supportedShopperInteractions
                                                        : []
                                                };
                                                const liElSwish = eXpress.html.querySelector(document, ".adyen-checkout__payment-method--swish");
                                                if (liElSwish)
                                                    injectSwishMessage(swishAppNotAvailable);
                                                initiatePayment(data, component, actions);
                                            }
                                            else {
                                                component.setStatus('ready');
                                                return false;
                                            }
                                        };
                                        if (recaptchaEnabled) {
                                            fetchRecaptchaToken().then(token => {
                                                submit(token);
                                            });
                                        }
                                        else {
                                            submit();
                                        }
                                    },
                                    onAdditionalDetails
                                };
                                dropInOpts = {
                                    openFirstPaymentMethod: false,
                                    openFirstStoredPaymentMethod: false,
                                    showStoredPaymentMethods: true,
                                    showRemovePaymentMethodButton: true,
                                    paymentMethodsConfiguration: {
                                        bcmc: {
                                            hasHolderName: true,
                                            enableStoreDetails: enableStoreDetails,
                                            holderNameRequired: true,
                                            onBrand: onBrand
                                        },
                                        card: {
                                            hasHolderName: true,
                                            enableStoreDetails: enableStoreDetails,
                                            holderNameRequired: true,
                                            hideCVC: false,
                                            onBrand: onBrand
                                        },
                                        applepay: {
                                            amount: {
                                                currency: currency,
                                                value: amount,
                                                countryCode: 'BE'
                                            },
                                            onClick: (resolve) => {
                                                validate();
                                                return resolve(true);
                                            }
                                        },
                                        paypal: {
                                            environment: environment,
                                            countryCode: countryCode,
                                            amount: {
                                                currency: currency,
                                                value: amount
                                            },
                                            onClick: () => {
                                                return validate();
                                            }
                                        },
                                        bcmc_mobile: {
                                            icon: eXpress.utils.resolveVersionedUrlCdn('/appdata/', 'img/payconiq.png')
                                        },
                                        threeDS2: { challengeWindowSize: '05' }
                                    },
                                    onSelect: (component) => {
                                        validate();
                                        selectedPaymentBrand = component.props.type;
                                        toggleDisableButtonState(resetButtonEl, false, false);
                                        toggleDisableAllButtonStates(false);
                                        const bankTransferEl = eXpress.html.querySelector(containerEl, ".technical-bank-transfer", false);
                                        bankTransferEl && deselectPaymentMethod();
                                        const message = containerEl.dataset.klarnamessage || "";
                                        const description = containerEl.dataset.klarnadescription || "";
                                        if (component._id) {
                                            const currentEl = eXpress.html.querySelector(containerEl, "#container-" + component._id, true);
                                            const obOptionalCvc = new MutationObserver((mutations) => {
                                                mutations.forEach((mutation) => {
                                                    if (!mutation.addedNodes)
                                                        return;
                                                    const optionalCvcEl = eXpress.html.querySelector(currentEl, ".adyen-checkout__field__cvc--optional", false);
                                                    if (optionalCvcEl)
                                                        optionalCvcEl.style.display = "none";
                                                });
                                            });
                                            obOptionalCvc.observe(currentEl, { childList: true, subtree: true, attributes: false, characterData: false });
                                            if (placeOrderContainerEl && message && description) {
                                                const liEl = eXpress.html.getParentWithClassName(currentEl, "adyen-checkout__payment-method--klarna");
                                                if (liEl) {
                                                    refreshMiniBasket && updateCartHandlingCost(1, 1);
                                                    if (obKlarna === undefined) {
                                                        obKlarna = new MutationObserver((mutations) => {
                                                            mutations.forEach((mutation) => {
                                                                if (!mutation.addedNodes)
                                                                    return;
                                                                injectKlarnaAdditionalFeeMessage(liEl, description, message);
                                                            });
                                                        });
                                                        obKlarna.observe(liEl, { childList: true, subtree: true, attributes: false, characterData: false });
                                                    }
                                                }
                                                else {
                                                    const noKlarnaLiEl = eXpress.html.getParentWithClassName(currentEl, paymentMethodClass);
                                                    toggleSelectedPaymentMethodState(noKlarnaLiEl, true);
                                                    refreshMiniBasket && updateCartHandlingCost(1, 3);
                                                }
                                            }
                                        }
                                    },
                                    onDisableStoredPaymentMethod,
                                    onReady: () => { injectExtraPaymentMethods(); }
                                };
                                adyenCheckoutObject = yield AdyenCheckout(configuration);
                                adyenDropInComponent = new Dropin(adyenCheckoutObject, dropInOpts).mount(containerEl);
                            }
                        }));
                        eXpress.html.addEventListener(resetButtonEl, 'click', (ev) => {
                            ev.preventDefault();
                            reset();
                        });
                    });
                    const reset = () => {
                        if (resetButtonEl && !resetButtonEl.classList.contains("a-button--disabled")) {
                            adyenCheckoutObject.remove(adyenDropInComponent);
                            eXpress.utils.showLoadingDialog(getPaymentMethods().then((res) => __awaiter(this, void 0, void 0, function* () {
                                adyenCheckoutObject.setOptions({
                                    paymentMethodsResponse: res
                                });
                                adyenDropInComponent = new Dropin(adyenCheckoutObject, dropInOpts).mount(containerEl);
                                refreshMiniBasket && updateCartHandlingCost(1, 3);
                                toggleDisableButtonState(resetButtonEl, true, false);
                                containerEl.scrollIntoView();
                            })));
                        }
                    };
                    yield init();
                    return {
                        dispose: () => { obKlarna && obKlarna.disconnect(); eventDisposables && eventDisposables.dispose(); },
                        reset
                    };
                });
            }
            checkout.createAdyenDropIn = createAdyenDropIn;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createConfirmation(containerEl, deps) {
                const beaContainerEl = eXpress.html.querySelector(containerEl, ".technical-bea-container", false);
                const beaSubmitButtonEl = eXpress.html.querySelector(containerEl, ".technical-bea-submit", false);
                const beaAccnrInputContainerEl = eXpress.html.querySelector(containerEl, ".technical-beaaccnr-input-container", false);
                const loginContainer = eXpress.html.querySelector(document, ".technical-login-container", false);
                const loginForm = eXpress.html.querySelector(document, ".technical-login-form", false);
                const loginAuthenticationLinks = eXpress.html.querySelector(document, ".technical-login", false);
                let loginFormComponent;
                const registerContainer = eXpress.html.querySelector(document, ".technical-register-container", false);
                const registerForm = eXpress.html.querySelector(document, ".technical-register-form", false);
                const eventDisposables = eXpress.utils.compositeDisposable([]);
                const { doMondoCall, showLoginPopup } = deps;
                let orderId;
                let beaAccnr;
                const onBeaSubmit = (e) => {
                    e.preventDefault();
                    if (beaContainerEl && beaAccnrInputContainerEl) {
                        beaAccnrInputContainerEl.classList.remove("a-form-input--error");
                        beaContainerEl.classList.remove("m-bea-form--success");
                        const beaAccnrEl = eXpress.html.querySelector(beaAccnrInputContainerEl, ".technical-beaaccnr", false);
                        if (beaAccnrEl && beaAccnrEl.value) {
                            beaAccnr = beaAccnrEl.value;
                            doMondoCall(orderId, beaAccnr).then((res) => {
                                if (res.success === 'False')
                                    beaAccnrInputContainerEl.classList.add("a-form-input--error");
                                else {
                                    beaContainerEl.classList.add("m-bea-form--success");
                                    beaContainerEl.scrollIntoView({ behavior: "smooth", block: "start" });
                                }
                            });
                        }
                        else {
                            beaAccnrInputContainerEl.classList.add("a-form-input--error");
                        }
                    }
                };
                const loggedInWithAccount = () => {
                    document.location.reload();
                };
                const init = () => {
                    if (beaSubmitButtonEl && eventDisposables && eventDisposables.add) {
                        orderId = beaSubmitButtonEl.getAttribute("data-orderid") || '';
                        eventDisposables.add([
                            eXpress.html.addEventListener(beaSubmitButtonEl, 'click', onBeaSubmit)
                        ]);
                    }
                    if (loginContainer && loginForm) {
                        loginFormComponent = eXpress.components.main.createStandardInlineLogin(loginContainer, loginForm, {
                            onOrderFlow: true,
                            showForgotPasswordPopup: deps.showForgotPasswordPopup,
                            popups: deps.popups
                        }, null, loggedInWithAccount);
                        loginFormComponent.hideCloseButton();
                        loginFormComponent.disableInput("email");
                    }
                    if (registerContainer && registerForm) {
                        eXpress.components.main.createStandardInlineRegister(registerContainer, registerForm, {
                            onOrderFlow: true,
                            showForgotPasswordPopup: deps.showForgotPasswordPopup,
                            popups: deps.popups
                        }, null, loggedInWithAccount);
                    }
                    loginAuthenticationLinks && loginAuthenticationLinks.addEventListener('click', _ => showLoginPopup(loginAuthenticationLinks.dataset.mode, loginAuthenticationLinks.dataset.email));
                };
                init();
                return {
                    dispose: () => { eventDisposables && eventDisposables.dispose(); },
                    loginForm: loginFormComponent
                };
            }
            checkout.createConfirmation = createConfirmation;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createDeliveryAddress(containerEl, deps) {
                const { formDeps, getAddress, isNew, disableDefaultAddress, countryChangeEnabled } = deps;
                const popupEl = eXpress.html.querySelector(document, '.p-delivery-address', true);
                const buttonContainerEl = eXpress.html.querySelector(popupEl, '.technical-delivery-address-button-container', true);
                const saveDeliveryAddressButtonEl = eXpress.html.querySelector(buttonContainerEl, '.technical-save-delivery-address-button', true);
                const deliveryAddressForm = checkout.createPersonalDataForm(eXpress.html.querySelector(containerEl, '.technical-delivery-address-form', true), {
                    onSubmit: formDeps.onSubmit,
                    getZipCodeDefinitionAsync: formDeps.getZipCodeDefinitionAsync,
                    getCitiesForCountryCodeAndSearchTerm: formDeps.getCitiesForCountryCodeAndSearchTerm,
                    getGetCitiesByZipCode: formDeps.getGetCitiesByZipCode,
                    alternativeSubmitButtonEl: saveDeliveryAddressButtonEl
                });
                // load the address , instead of reloading the popup each time it opens
                if (!isNew) {
                    eXpress.utils.showLoadingDialog(getAddress()
                        .then(res => deliveryAddressForm.fillFormData(res, disableDefaultAddress, countryChangeEnabled)));
                }
                else {
                    // update with default country, should never be undefined
                    deliveryAddressForm.updateCountry(containerEl.dataset.defaultRegion, false);
                }
                return {
                    setErrors: deliveryAddressForm.setErrors,
                    dispose: deliveryAddressForm.dispose,
                };
            }
            checkout.createDeliveryAddress = createDeliveryAddress;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createDeliveryInfo(deliveryFormEl, rightColumnEl, gtmData, deps) {
                let blocked = false;
                const { deliveryAddressPickerPopup, changeMiniBasketServerSide, getLabelAsync, pickupPickerPopup, updateDeliveryChoices, pickCorrectAddressPopup, submitPartialDeliveryAddress, hideTopMessage, showTopMessage, iconsPopup, logError, } = deps;
                const deliveryAddressPickerButtonEl = eXpress.html.querySelector(deliveryFormEl, ".technical-delivery-address-picker-button-homedelivery");
                const pickupPickerButtonEl = eXpress.html.querySelector(deliveryFormEl, ".technical-delivery-address-picker-button-pickupdelivery");
                const nextButtons = eXpress.html.querySelectorAll(rightColumnEl, ".technical-checkout-step-confirm-button");
                const groups = eXpress.html.querySelectorAll(deliveryFormEl, ".technical-method-group");
                const radios = eXpress.html.querySelectorAll(deliveryFormEl, ".technical-delivery-time-picker-radio");
                const debugSectionEl = eXpress.html.querySelector(deliveryFormEl, "#debugSection");
                const prettyButtonEl = eXpress.html.querySelector(deliveryFormEl, "#pretty");
                const thumbInfoEls = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-time-picker-thumb-info');
                const goToDeliveryMethodsLabels = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-method-group-gotodatepicker');
                const iconsEls = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-icons-popup');
                const addressPickerClass = '.technical-method-adress-picker';
                let resetSelectedRadioButtonAfterSlideChange = true;
                const activeClass = "m-delivery-time-selector__option--selected";
                const disabledClass = "m-delivery-time-selector__option--disabled";
                let currentVisibleItems;
                const changeHomeDeliveryAddress = (newAddress1, newAddress2, jsonAddress) => {
                    const homeDeliveryAddress1El = eXpress.html.querySelector(deliveryFormEl, '.technical-home-address1', false);
                    const homeDeliveryAddress2El = eXpress.html.querySelector(deliveryFormEl, '.technical-home-address2', false);
                    selectHomeDeliveryOption();
                    const radio = eXpress.html.querySelector(deliveryFormEl, 'input[type="radio"][value*="home"]');
                    if (radio)
                        radio.dataset.currentAddress = jsonAddress;
                    if (homeDeliveryAddress1El)
                        homeDeliveryAddress1El.innerHTML = newAddress1;
                    if (homeDeliveryAddress2El)
                        homeDeliveryAddress2El.innerHTML = newAddress2;
                };
                const selectHomeDeliveryOption = () => {
                    const radio = eXpress.html.querySelector(deliveryFormEl, 'input[type="radio"][value*="home"]');
                    if (radio) {
                        if (radio.dataset.forceaddresspopup === "true")
                            radio.dataset.forceaddresspopup = 'false';
                        if (!radio.checked)
                            radio.click();
                    }
                };
                const getSelectedMethodGroup = () => {
                    const selectedMethod = eXpress.html.querySelector(deliveryFormEl, 'input[name="methodGroup"]:checked');
                    if (!selectedMethod)
                        return undefined;
                    const selectedMethodGroupStr = selectedMethod.value;
                    if (!selectedMethodGroupStr)
                        return undefined;
                    return selectedMethodGroupStr;
                };
                const getDeliveryChoicesItemGroup = (selectedMethodGroupStr) => {
                    const items = [];
                    const radios = eXpress.html.querySelectorAll(deliveryFormEl, 'input[name^="' + selectedMethodGroupStr + '-"]:checked');
                    radios.forEach(r => {
                        const ids = r.dataset.cartitemids;
                        if (ids)
                            items.push({
                                SelectedMethod: r.value,
                                CartItemIds: ids.split('|'),
                                ProductionSchedule: parseInt(r.dataset.prodsched || "2", 10)
                            });
                    });
                    return items;
                };
                const getDeliveryChoicesItemGroups = (selectedMethodGroupStr, withDefaults = false) => {
                    const items = [];
                    const radios = eXpress.html.querySelectorAll(deliveryFormEl, 'input[name^="' + selectedMethodGroupStr + '-"]');
                    const groups = radios.map(r => r.name).filter((value, index, self) => self.indexOf(value) === index);
                    groups.forEach(g => {
                        const radiosInGroup = radios.filter(r => r.name == g);
                        let selected = radiosInGroup.find(r => r.checked);
                        if (!selected && withDefaults) {
                            selected = radiosInGroup.find(r => !r.checked && r.dataset.default === 'true');
                        }
                        if (selected) {
                            const ids = selected.dataset.cartitemids;
                            if (ids)
                                items.push({
                                    SelectedMethod: selected.value,
                                    CartItemIds: ids.split('|'),
                                    ProductionSchedule: parseInt(selected.dataset.prodsched || "2", 10)
                                });
                        }
                    });
                    return items;
                };
                const calculateSelectedShipping = () => {
                    const selectedMethodGroupStr = getSelectedMethodGroup();
                    if (!selectedMethodGroupStr) {
                        document.location.reload();
                        return;
                    }
                    const items = getDeliveryChoicesItemGroups(selectedMethodGroupStr);
                    if (!items || items.length === 0)
                        return; // Is also called on page load when there are no selections yet
                    const postalInformationEl = eXpress.html.querySelector(deliveryFormEl, '#postal_information_personal_data', false);
                    let postalInformation = '';
                    if (postalInformationEl)
                        postalInformation = postalInformationEl.value;
                    changeMiniBasketServerSide(selectedMethodGroupStr, items, postalInformation);
                };
                const onWindowResize = () => {
                    setRightColTopPosition(rightColumnEl);
                    rightColumnEl.style.transform = "0";
                };
                const setRightColTopPosition = (div) => {
                    if (window.innerHeight < div.clientHeight)
                        div.style.top = (window.innerHeight - div.clientHeight - 20) + 'px';
                    else
                        div.style.top = '0px';
                };
                const prettyFi = () => {
                    const textEl = eXpress.html.querySelector(debugSectionEl, "textarea");
                    if (textEl) {
                        const ugly = textEl.value;
                        const json = JSON.parse(ugly);
                        textEl.value = JSON.stringify(json, undefined, 4);
                    }
                };
                const onNextButtonClick = (event) => {
                    if (blocked)
                        return;
                    const buttonEl = (event.currentTarget || event.srcElement);
                    const button = components.main.createButton(buttonEl);
                    button.disable();
                    /* Validation section
                     * 1) Check if any of the groups are checked by the user
                     * 2) Check if all packages have a method selected
                     * 3) Check if the address for pickup is selected
                     * */
                    // 1) Check if either homedelivery or pickupdelivery is checked
                    if (eXpress.html.querySelectorAll(deliveryFormEl, 'input[name="methodGroup"]:checked').length === 0) {
                        getLabelAsync("Label.Delivery.DeliveryMethod.NoDeliveryMethodSelected").then(res => showTopMessage(components.main.PageLogStyle.Error, res));
                        button.enable();
                        return;
                    }
                    const selectedMethod = eXpress.html.querySelector(deliveryFormEl, 'input[name="methodGroup"]:checked');
                    if (!selectedMethod) {
                        document.location.reload();
                        return;
                    }
                    const selectedMethodGroupStr = selectedMethod.value;
                    if (!selectedMethodGroupStr) {
                        document.location.reload();
                        return;
                    }
                    // 2) Check every package
                    if (eXpress.html.querySelectorAll(deliveryFormEl, '#choices-' + selectedMethodGroupStr + ' .technical-method-group-items-content').length !==
                        eXpress.html.querySelectorAll(deliveryFormEl, '#choices-' + selectedMethodGroupStr + ' .technical-method-group-items-content .technical-delivery-time-picker-radio:checked').length) {
                        getLabelAsync("Label.Delivery.DeliveryMethod.NoDeliveryMomentSelected").then(res => showTopMessage(components.main.PageLogStyle.Error, res));
                        button.enable();
                        return;
                    }
                    // 3) Note: :not([data-forceaddresspopup="true"]) -> Means the user has not yet selected a pcikup point!
                    if (eXpress.html.querySelectorAll(deliveryFormEl, 'input[name="methodGroup"]:checked:not([data-forceaddresspopup="true"])').length === 0) {
                        getLabelAsync("Label.Delivery.DeliveryMethod.NoPickUpPointSelected").then(res => showTopMessage(components.main.PageLogStyle.Error, res));
                        button.enable();
                        return;
                    }
                    if (selectedMethodGroupStr === 'homedelivery' && selectedMethod.dataset.currentAddress) {
                        // The current address is a JSON structure on the current-address attribute
                        const address = JSON.parse(selectedMethod.dataset.currentAddress);
                        const useExternalAddressValidation = (selectedMethod.dataset.useexternaladdressvalidation || 'true') === "true";
                        if (useExternalAddressValidation)
                            // Check if the address has a suggestion from a third party validator
                            components.main.validateAddressAsync(address.Street || '', address.HouseNumber || '', address.ZipCode || '', address.City || '', address.RegionCountryISO || '', { logError }).then(res => {
                                if (res) {
                                    pickCorrectAddressPopup([
                                        { Street: eXpress.utils.capitalizeFirstLetterOfWords(res.street), HouseNumber: res.nr, ZipCode: res.zip, City: res.city, RegionCountryISO: address.RegionCountryISO, BoxNumber: address.BoxNumber, IsDefault: true },
                                        { Street: address.Street, HouseNumber: address.HouseNumber, ZipCode: address.ZipCode, City: address.City, BoxNumber: address.BoxNumber, RegionCountryISO: address.RegionCountryISO }
                                    ], () => { button.enable(); }, (popup) => {
                                        // Set onclicks for the address tiles
                                        const list = eXpress.html.querySelector(popup, '.technical-pick-delivery-address-container', true);
                                        for (let i = 0; i < list.children.length; i++) {
                                            const input = eXpress.html.querySelector(list.children[i], 'input', true);
                                            eXpress.html.addEventListener(input, 'change', (ev) => {
                                                ev.preventDefault();
                                            });
                                            eXpress.html.addEventListener(list.children[i], 'click', (ev) => {
                                                // remove the active class from the current selected item
                                                const current = eXpress.html.querySelector(list, '.technical-default-address-tile.m-address-tile--active,.technical-address-tile.m-address-tile--active', true);
                                                current.classList.remove('m-address-tile--active');
                                                eXpress.html.querySelector(current, 'input', true).checked = false;
                                                if (ev.currentTarget) {
                                                    const changed = eXpress.html.querySelector(ev.currentTarget, '.technical-default-address-tile,.technical-address-tile', true);
                                                    changed.classList.add('m-address-tile--active');
                                                    eXpress.html.querySelector(changed, 'input', true).checked = true;
                                                }
                                            });
                                        }
                                        // Set the onclick for the continue button
                                        const continueButton = eXpress.html.querySelector(popup, '.technical-add-delivery-address-button', true);
                                        eXpress.html.addEventListener(continueButton, 'click', () => {
                                            const addressTile = eXpress.html.querySelector(popup, '.technical-default-address-tile', true);
                                            let hasSameDeliveryAddress = false;
                                            if (addressTile)
                                                hasSameDeliveryAddress = addressTile.getAttribute('data-hassamedeliveryaddress') === "True";
                                            const recommended = eXpress.html.querySelector(popup, '.technical-default-address-tile input', true);
                                            if (recommended.checked) {
                                                eXpress.analytics.trackAddressValidationEvent("ClickedAddressSuggestionDeliveryOptions");
                                                const address = JSON.parse(recommended.value);
                                                if (address.Street) {
                                                    // The customer decided to change the address
                                                    submitPartialDeliveryAddress(address.Street, hasSameDeliveryAddress).then(() => {
                                                        doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                                                    });
                                                }
                                            }
                                            else {
                                                eXpress.analytics.trackAddressValidationEvent("ClickedOwnAddressDeliveryOptions");
                                                doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                                            }
                                        });
                                    });
                                }
                                else {
                                    doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                                }
                            });
                        else
                            doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                        return;
                    }
                    doActualSubmit(buttonEl, button, selectedMethodGroupStr);
                };
                const doActualSubmit = (buttonEl, button, selectedMethodGroupStr) => {
                    // Actual submitting
                    blocked = true;
                    const items = getDeliveryChoicesItemGroup(selectedMethodGroupStr);
                    if (!buttonEl.dataset)
                        throw new Error("Clicking next step on deliveryoptions: Button has no dataset: button css classes: " + buttonEl.className);
                    if (!buttonEl.dataset.posid)
                        throw new Error("Clicking next step on deliveryoptions: Button has no posID: button css classes: " + buttonEl.className);
                    if (!buttonEl.dataset.accountid)
                        throw new Error("Clicking next step on deliveryoptions: Button has no accountID: button css classes: " + buttonEl.className);
                    if (!buttonEl.dataset.cartid)
                        throw new Error("Clicking next step on deliveryoptions: Button has cartID: button css classes: " + buttonEl.className);
                    const postalInformationEl = eXpress.html.querySelector(deliveryFormEl, '#postal_information_personal_data', false);
                    let postalInformation = '';
                    if (postalInformationEl)
                        postalInformation = postalInformationEl.value;
                    eXpress.utils.showLoadingDialog(updateDeliveryChoices((buttonEl.dataset.posid), (buttonEl.dataset.accountid), (buttonEl.dataset.cartid), selectedMethodGroupStr, items, postalInformation)
                        .then(res => {
                        if (res) {
                            if (gtmData) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push(JSON.parse(gtmData));
                            }
                            document.location.href = res;
                            return eXpress.utils.wait(99999);
                        }
                        else {
                            button.enable();
                        }
                    }));
                };
                const onTimeSelectorClick = (clickedEl, allEls) => {
                    const selectedEl = allEls.find(el => eXpress.html.hasClass(el, activeClass));
                    if (selectedEl) {
                        // click on the selected el
                        if (selectedEl.dataset.day === clickedEl.dataset.day)
                            return;
                        eXpress.html.removeClass(selectedEl, activeClass);
                    }
                    eXpress.html.addClass(clickedEl, activeClass);
                    const selectedDay = clickedEl.dataset.day || '';
                    const itemGroupContentEl = eXpress.html.getParentWithClassName(clickedEl, 'technical-method-group-items-content');
                    if (itemGroupContentEl) {
                        // Disable some radio buttons
                        let resetUserChoice = false;
                        let radioWithLowestPrice;
                        const deliveryTypesRadioContainerEl = eXpress.html.querySelector(itemGroupContentEl, '.technical-delivery-types-radio-container', true);
                        const radios = eXpress.html.querySelectorAll(deliveryTypesRadioContainerEl, 'input[type="radio"]');
                        const selectedRadio = eXpress.html.querySelector(deliveryTypesRadioContainerEl, 'input[type="radio"]:checked');
                        for (let i = 0; i < radios.length; i++) {
                            const radio = radios[i];
                            const allowedDatesString = radio.dataset.days || '';
                            let radioNoLongerAvailable = true;
                            radio.dataset.availablefordate = 'false';
                            allowedDatesString.split('|').forEach(d => {
                                if (selectedDay === d) {
                                    radioNoLongerAvailable = false;
                                    radio.dataset.availablefordate = 'true';
                                    // Define the one with the lowest extra cost.
                                    // If we need to reset (resetUserOption), we need to select the cheapest available option and not the first one
                                    if (radio.offsetParent) { // radio.offsetParent -> element is visible/hidden
                                        if (radioWithLowestPrice) {
                                            let currentLowestExtraPrice = 0;
                                            let newExtraPrice = 0;
                                            if (radioWithLowestPrice.dataset.extraprice)
                                                currentLowestExtraPrice = parseFloat(radioWithLowestPrice.dataset.extraprice);
                                            if (radio.dataset.extraprice)
                                                newExtraPrice = parseFloat(radio.dataset.extraprice);
                                            if (newExtraPrice < currentLowestExtraPrice)
                                                radioWithLowestPrice = radio;
                                        }
                                        else {
                                            radioWithLowestPrice = radio;
                                        }
                                    }
                                }
                            });
                            // The method was checked and is now disabled -> Eeeek
                            if (radioNoLongerAvailable && radio === selectedRadio)
                                resetUserChoice = true;
                        }
                        if (!selectedRadio || (resetUserChoice && resetSelectedRadioButtonAfterSlideChange)) {
                            // Select the cheapest non-disabled one or the first non-disabled one!
                            for (let i = 0; i < radios.length; i++) {
                                const radio = radios[i];
                                if (radio.offsetParent && radio.dataset.availablefordate === 'true' && (radioWithLowestPrice && radio.id === radioWithLowestPrice.id)) { // radio.offsetParent -> element is visible/hidden
                                    radio.click();
                                    break;
                                }
                            }
                        }
                        resetSelectedRadioButtonAfterSlideChange = true;
                    }
                };
                const addOnTimeSelectorClick = (clickedEl, allEls) => {
                    clickedEl.addEventListener('click', () => onTimeSelectorClick(clickedEl, allEls));
                };
                const initTimeSelectorElements = (groupEl) => {
                    const timeSelectorEls = eXpress.html.querySelectorAll(groupEl, '.technical-delivery-time-selector:not(.illegal)');
                    timeSelectorEls.forEach(el => {
                        if (!eXpress.html.hasClass(el, disabledClass))
                            addOnTimeSelectorClick(el, timeSelectorEls);
                    });
                };
                const onGroupChange = (e) => {
                    const radio = (e.target || e.srcElement);
                    if (radio.checked) {
                        hideTopMessage();
                        const val = radio.value;
                        if (!deliveryFormEl)
                            return;
                        // search for label go to delivery methods
                        const deliveryAddresses = eXpress.html.querySelectorAll(deliveryFormEl, addressPickerClass);
                        for (let i = 0; i < deliveryAddresses.length; i++) {
                            const labelDeliveryMethods = eXpress.html.querySelector(deliveryAddresses[i], '.technical-method-group-gotodatepicker', false);
                            const radiobutton = eXpress.html.querySelector(deliveryAddresses[i], '.technical-method-group');
                            if (!labelDeliveryMethods || !radiobutton)
                                continue;
                            labelDeliveryMethods.classList.toggle('a-link--disabled', !radiobutton.checked);
                        }
                        const methodGroupContentEl = eXpress.html.querySelector(deliveryFormEl, '.technical-method-group-content', true);
                        eXpress.html.show(methodGroupContentEl);
                        const items = eXpress.html.querySelectorAll(deliveryFormEl, '.technical-method-group-content-item');
                        items.map((item) => {
                            if (item.id !== 'choices-' + val) {
                                eXpress.html.hide(item);
                            }
                            else {
                                eXpress.html.show(item);
                                checkAndHideIllegalMethods(radio.dataset.forceshipmentmethods || '', item);
                                const groupItemsContentEls = eXpress.html.querySelectorAll(item, '.technical-method-group-items-content');
                                groupItemsContentEls.forEach(groupItem => initTimeSelectorElements(groupItem));
                            }
                        });
                        truncateThumbs();
                        currentVisibleItems = document.getElementById('choices-' + val);
                        if (currentVisibleItems) {
                            calculateSelectedShipping();
                        }
                        if (radio.dataset.forceaddresspopup === 'true' && pickupPickerButtonEl && !disableButtonClick) {
                            disableButtonClick = true;
                            pickupPickerPopup(pickupPickerButtonEl.dataset.deliverymethod || '', parseFloat(pickupPickerButtonEl.dataset.baseprice || '0')).always(() => { disableButtonClick = false; });
                        }
                    }
                };
                const checkAndHideIllegalMethods = (forceShipmentMethod, groupContentItem) => {
                    // Return the new methods that need to be checked
                    const allPackages = eXpress.html.querySelectorAll(groupContentItem, '.technical-method-group-items-content');
                    let visibleRadioCount = 0;
                    allPackages.forEach(onePackage => {
                        // First we re-enable all radio buttons
                        const allRadios = eXpress.html.querySelector(onePackage, '.technical-delivery-types-radio-container', true).children;
                        for (let i = 0; i < allRadios.length; i++) {
                            eXpress.html.show(allRadios[i]);
                        }
                        const forceShipmentMethods = forceShipmentMethod ? forceShipmentMethod.toLowerCase().split(',') : [];
                        if (forceShipmentMethods.length == 0) {
                            return;
                        }
                        let selectedRadioWasHidden = false;
                        // hide all delivery method radio buttons that are not this method!
                        const foundDays = [];
                        let firstVisibleMethodRadioButton = null;
                        let firstActivatedDay = "";
                        for (let i = 0; i < allRadios.length; i++) {
                            const childRadio = eXpress.html.querySelector(allRadios[i], '.technical-delivery-time-picker-radio', true);
                            if (!forceShipmentMethods.includes(childRadio.value.toLowerCase()) && childRadio.value.toLowerCase() !== 'email') {
                                if (childRadio.checked)
                                    selectedRadioWasHidden = true;
                                eXpress.html.hide(allRadios[i]);
                            }
                            else {
                                if (!firstVisibleMethodRadioButton) {
                                    firstVisibleMethodRadioButton = childRadio;
                                }
                                const radioDays = childRadio.dataset.days ? childRadio.dataset.days.split("|") : undefined;
                                if (radioDays) {
                                    if (!firstActivatedDay)
                                        firstActivatedDay = radioDays[0];
                                    foundDays.push(...radioDays);
                                }
                                visibleRadioCount++;
                            }
                        }
                        // Should we hide any of the days? Only if no methods are left for it!
                        const days = eXpress.html.querySelectorAll(onePackage, '.technical-delivery-time-selector');
                        let activateDayDiv = null;
                        for (let i = 0; i < days.length; i++) {
                            const day = days[i].dataset.day;
                            if (day) {
                                if (foundDays.indexOf(day) > -1) {
                                    days[i].classList.remove("illegal", "u-hide");
                                    if (!activateDayDiv && day === firstActivatedDay)
                                        activateDayDiv = days[i];
                                }
                                else {
                                    days[i].classList.add("illegal", "u-hide");
                                }
                            }
                        }
                        // We have hidden the selected method -> reselect a new one
                        // If we only have one left, select it
                        if (firstVisibleMethodRadioButton && (selectedRadioWasHidden || visibleRadioCount === 1)) {
                            firstVisibleMethodRadioButton.checked = true;
                            // select the first day for that method
                            if (activateDayDiv) {
                                // Deselect the previous selected
                                days.forEach(day => {
                                    day.classList.remove(activeClass);
                                });
                                // Activate selected
                                activateDayDiv.classList.add(activeClass);
                            }
                        }
                    });
                };
                const onRadioChange = (e) => {
                    hideTopMessage();
                    const radio = (e.target || e.srcElement);
                    if (radio.checked)
                        calculateSelectedShipping();
                    // Possibly, we need to change the active date because this delivery method doesn't support it!
                    const parent = eXpress.html.getParentWithClassName(radio, 'technical-method-group-items-content');
                    if (parent) {
                        const radios = eXpress.html.querySelectorAll(parent, 'input[type="radio"]');
                        const timeSelectorEls = eXpress.html.querySelectorAll(parent, '.technical-delivery-time-selector:not(.illegal)');
                        // Temp disable all radio buttons to prevent this event to be fired again
                        radios.forEach(el => el.disabled = true);
                        // Get the active date slide
                        const activeTimeSelector = eXpress.html.querySelector(parent, '.' + activeClass);
                        const selectedTimeSelectorDay = (activeTimeSelector === null || activeTimeSelector === void 0 ? void 0 : activeTimeSelector.dataset.day) || '';
                        const radioDateString = radio.dataset.days || '';
                        const radioAllAllowedDates = radioDateString.split('|');
                        let switchTimeSelector = true;
                        radioAllAllowedDates.forEach(d => {
                            if (d === selectedTimeSelectorDay)
                                switchTimeSelector = false;
                        });
                        if (switchTimeSelector) {
                            if (activeClass && activeTimeSelector)
                                eXpress.html.removeClass(activeTimeSelector, activeClass);
                            timeSelectorEls.every(el => {
                                const slideDay = el.dataset.day || '';
                                if (radioAllAllowedDates.indexOf(slideDay) >= 0) {
                                    eXpress.html.addClass(el, activeClass);
                                    return false;
                                }
                                return true;
                            });
                        }
                        radios.forEach(el => el.disabled = false);
                    }
                };
                let disableButtonClick = false;
                if (debugSectionEl && prettyButtonEl)
                    eXpress.html.addEventListener(prettyButtonEl, "click", prettyFi);
                eXpress.html.addEventListener(window, "resize", eXpress.utils.debounce(onWindowResize, 250));
                if (deliveryAddressPickerButtonEl)
                    eXpress.html.addEventListener(deliveryAddressPickerButtonEl, 'click', () => {
                        if (!disableButtonClick) {
                            disableButtonClick = true;
                            deliveryAddressPickerPopup().always(() => { disableButtonClick = false; });
                        }
                    });
                if (pickupPickerButtonEl)
                    eXpress.html.addEventListener(pickupPickerButtonEl, 'click', () => {
                        if (!disableButtonClick) {
                            disableButtonClick = true;
                            pickupPickerPopup(pickupPickerButtonEl.dataset.deliverymethod || '', parseFloat(pickupPickerButtonEl.dataset.baseprice || '0')).always(() => { disableButtonClick = false; });
                        }
                    });
                if (nextButtons)
                    nextButtons.forEach((nextButton) => eXpress.html.addEventListener(nextButton, "click", onNextButtonClick));
                if (groups)
                    groups.forEach((group) => {
                        var _a;
                        eXpress.html.addEventListener(group, "click", onGroupChange);
                        (_a = group.closest(addressPickerClass)) === null || _a === void 0 ? void 0 : _a.classList.remove('skeleton-loading');
                    });
                if (radios)
                    radios.forEach((radio) => eXpress.html.addEventListener(radio, "change", onRadioChange));
                if (goToDeliveryMethodsLabels)
                    goToDeliveryMethodsLabels.forEach((label) => eXpress.html.addEventListener(label, 'click', (e) => {
                        const labelHtmlElement = label;
                        if (label.classList.contains('a-link--disabled') || !labelHtmlElement || !labelHtmlElement.hash)
                            e.preventDefault();
                    }));
                // Set current base price
                const checkedGroup = groups.filter(g => g.checked);
                if (checkedGroup.length > 0) {
                    const group = checkedGroup[0].value;
                    currentVisibleItems = document.getElementById('choices-' + group);
                    if (currentVisibleItems) {
                        const forceShipmentMethods = checkedGroup[0].dataset.forceshipmentmethods;
                        if (forceShipmentMethods && forceShipmentMethods.length > 0)
                            checkAndHideIllegalMethods(forceShipmentMethods, currentVisibleItems);
                        const groupContentEls = eXpress.html.querySelectorAll(currentVisibleItems, '.technical-method-group-items-content');
                        groupContentEls.forEach(el => initTimeSelectorElements(el));
                    }
                }
                const truncateThumbs = () => {
                    thumbInfoEls.map(el => {
                        const temp = el.innerHTML;
                        el.innerHTML = 'Test</br>Test';
                        const height = el.clientHeight;
                        el.innerHTML = temp;
                        shave(el, height, { character: '\u2026', spaces: false });
                    });
                };
                eXpress.html.addEventListener(window, "resize", eXpress.utils.debounce(truncateThumbs, 250));
                iconsEls.forEach(i => {
                    eXpress.html.addEventListener(i, "click", (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (disableButtonClick)
                            return;
                        disableButtonClick = true;
                        iconsPopup('Label.Delivery.DeliveryMethod.PickUpPoint.Info.Title', 'Label.Delivery.DeliveryMethod.PickUpPoint.Info').always(() => disableButtonClick = false);
                    });
                });
                truncateThumbs();
                // Set top of right column so it sticks to the bottom + observe its resizes
                const resizeObserver = new ResizeObserver((entries) => {
                    for (const entry of entries)
                        if (entry.contentRect && entry.target)
                            if (entry.contentRect.height != entry.target.clientHeight)
                                setRightColTopPosition(entry.target);
                });
                resizeObserver.observe(rightColumnEl);
                return {
                    changeHomeDeliveryAddress,
                    selectHomeDeliveryOption
                };
            }
            checkout.createDeliveryInfo = createDeliveryInfo;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createDiscount(discountEl, deps) {
                let formEl;
                let buttonEl;
                let inputContainerEl;
                let inputEl;
                let promoCodeEl;
                let deleteEl;
                let discountTextEl;
                let mgmLinkEl;
                let eventDisposables;
                let introClicker;
                const onMglLinkElClick = (e) => {
                    e.preventDefault();
                    const mgmPromoCode = discountTextEl.dataset.promocode || '';
                    deps.changePromoCode(mgmPromoCode).then(res => {
                        discountTextEl.classList.add('u-hide');
                        if (res.InvalidPromoMessage) {
                            onDeleteClick(mgmPromoCode);
                            inputContainerEl.classList.add("a-form-input--error");
                            const messageEl = eXpress.html.querySelector(inputContainerEl, '.technical-discount-error', false);
                            if (messageEl)
                                messageEl.innerHTML = res.InvalidPromoMessage;
                            return;
                        }
                        eXpress.analytics.trackMgmEvent('MGMPromoCodeRe-enabled');
                        if (promoCodeEl)
                            promoCodeEl.innerHTML = mgmPromoCode;
                        discountEl.classList.add('m-discount--success');
                        if (deps.refreshMiniBasket)
                            deps.refreshMiniBasket(res.NewMiniBasketHtml);
                    });
                };
                const onIntroClick = () => {
                    initIntro();
                    inputContainerEl.classList.remove("a-form-input--error");
                };
                const onButtonClick = (event) => {
                    event.preventDefault();
                    const promoCode = inputEl.value;
                    if (!promoCode)
                        return;
                    const buttonDisabledClass = 'a-button--disabled';
                    // already disabled -> skip
                    if (buttonEl.classList.contains(buttonDisabledClass))
                        return;
                    // disable the button
                    buttonEl.classList.add(buttonDisabledClass);
                    const reEnableButton = () => {
                        clearTimeout(buttonDisableTimeout);
                        buttonEl.classList.remove(buttonDisabledClass);
                    };
                    const buttonDisableTimeout = setTimeout(() => reEnableButton(), 10000); // re-enable the button after 10 sec, just in case
                    // check if there are special characters
                    if (!eXpress.utils.isValidTextWithoutAngleBrackets(promoCode)) {
                        setErrorMessage(eXpress.html.sanitize(promoCode));
                        reEnableButton();
                        return;
                    }
                    clearError();
                    deps.changePromoCode(promoCode).then(res => {
                        if (res.InvalidPromoMessage) {
                            inputContainerEl.classList.add("a-form-input--error");
                            const messageEl = eXpress.html.querySelector(inputContainerEl, '.technical-discount-error', false);
                            if (messageEl)
                                messageEl.innerHTML = res.InvalidPromoMessage;
                        }
                        else {
                            if (promoCodeEl)
                                promoCodeEl.innerHTML = promoCode;
                            discountEl.classList.add('m-discount--success');
                            if (deps.refreshMiniBasket)
                                deps.refreshMiniBasket(res.NewMiniBasketHtml);
                        }
                        reEnableButton();
                    });
                };
                const clearError = () => {
                    inputContainerEl.classList.remove("a-form-input--error");
                };
                const refreshServerSide = (newContent) => {
                    if (newContent) {
                        replaceHtml(newContent);
                        return;
                    }
                };
                const replaceHtml = (htmlString) => {
                    const node = eXpress.html.htmlToElement(htmlString);
                    if (node) {
                        discountEl.replaceWith(node);
                        discountEl = node;
                        addHandlers();
                    }
                };
                const onDeleteClick = (overrideinputValue) => {
                    deps.changePromoCode('').then(res => {
                        inputEl.value = overrideinputValue || '';
                        formEl.classList.add("m-discount--slide");
                        discountEl.classList.remove('m-discount--success');
                        discountTextEl.classList.add("u-hide");
                        if (deps.refreshMiniBasket)
                            deps.refreshMiniBasket(res.NewMiniBasketHtml);
                    });
                };
                const initIntro = () => {
                    // Once clicked on the intro, it never comes back, so we remove it + remove the handler!
                    discountEl.classList.remove("m-discount--clickable");
                    introClicker.dispose();
                    // We also show the next step
                    formEl.classList.add("m-discount--slide");
                };
                const setErrorMessage = (promoCode, error) => {
                    const messageEl = eXpress.html.querySelector(inputContainerEl, '.technical-discount-error', false);
                    inputContainerEl.classList.add("a-form-input--error");
                    if (messageEl) {
                        const messageElDataError = error ? error : messageEl.getAttribute("data-error");
                        if (messageElDataError)
                            messageEl.innerHTML = messageElDataError.replace("[promocode]", promoCode);
                    }
                };
                const addHandlers = () => {
                    formEl = eXpress.html.querySelector(discountEl, ".technical-discount-from", true);
                    buttonEl = eXpress.html.querySelector(discountEl, ".technical-discount-button", true);
                    inputContainerEl = eXpress.html.querySelector(formEl, ".technical-discount-inputcontainer", true);
                    inputEl = eXpress.html.querySelector(inputContainerEl, ".technical-discount-input", true);
                    promoCodeEl = eXpress.html.querySelector(discountEl, ".technical-discount-promocode", false);
                    deleteEl = eXpress.html.querySelector(discountEl, ".technical-discount-delete", true);
                    discountTextEl = eXpress.html.querySelector(discountEl, '.technical-discount-text', true);
                    mgmLinkEl = eXpress.html.querySelector(discountTextEl, '.technical-apply-mgm', false);
                    if (eventDisposables)
                        dispose();
                    eventDisposables = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(buttonEl, 'click', onButtonClick),
                        eXpress.html.addEventListener(deleteEl, 'click', _ => onDeleteClick()),
                        eXpress.html.addEventListener(inputEl, 'focus', clearError),
                        eXpress.html.addEventListener(formEl, 'submit', onButtonClick)
                    ]);
                    introClicker = eXpress.html.addEventListener(discountEl, 'click', onIntroClick);
                    if (mgmLinkEl)
                        eXpress.html.addEventListener(mgmLinkEl, 'click', onMglLinkElClick);
                    const invalidPromoCode = discountEl.dataset.invalidpromocode;
                    const invalidPromoError = discountEl.dataset.invalidpromoerror;
                    if (invalidPromoCode && invalidPromoError) {
                        initIntro();
                        setErrorMessage(invalidPromoCode, invalidPromoError);
                    }
                };
                const dispose = () => {
                    if (introClicker)
                        introClicker.dispose();
                    eventDisposables.dispose();
                };
                addHandlers();
                return {
                    dispose: () => dispose(),
                    refreshServerSide: (newContent) => refreshServerSide(newContent)
                };
            }
            checkout.createDiscount = createDiscount;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createGoogleMap(containerEl, googleApiKey, googleMapId, options = {}) {
                const apiKey = googleApiKey;
                const mapId = googleMapId;
                let googleMapEl;
                let infoWindow;
                let isInitialized = false;
                let isInError = false;
                let markerInfos = [];
                let currentMapCenter = { latitude: 0, longitude: 0 };
                let disableMapRecenter = false;
                let mapRecenterTimeout;
                const { mapRecentered } = options;
                const centerMap = (latitude, longitude) => {
                    if (isInitialized) {
                        if (currentMapCenter.latitude != latitude || currentMapCenter.longitude != longitude)
                            googleMapEl.setCenter(new google.maps.LatLng(latitude, longitude, false));
                        currentMapCenter = { latitude, longitude };
                    }
                    else if (!isInError)
                        setTimeout(() => { centerMap(latitude, longitude); }, 500);
                };
                const clearMarkers = () => {
                    markerInfos.forEach(m => m.MapsMarker.map = null);
                    markerInfos = [];
                };
                const setMarkerContent = (markerInfo) => {
                    if (markerInfo.IsSelected) {
                        return;
                    }
                    if (!infoWindow) {
                        infoWindow = new google.maps.InfoWindow({ minWidth: 280 });
                    }
                    else {
                        infoWindow.close();
                    }
                    infoWindow.setContent(markerInfo.Marker.Text);
                    disableMapRecenter = true; // Why? The below function will recenter the map on the clicked marker, we don't want to reload the list
                    clearTimeout(mapRecenterTimeout);
                    mapRecenterTimeout = setTimeout(() => { disableMapRecenter = false; }, 2000); // Below function is async, no way to know when it is done
                    infoWindow.open({ anchor: markerInfo.MapsMarker, shouldFocus: false });
                    // Reset selection of all other markerInfos
                    markerInfos.forEach(m => {
                        m.MapsMarker.content = getNewPin(markerInfo.Marker, false);
                        m.IsSelected = false;
                    });
                    // Set a new, enlarged, marker
                    markerInfo.MapsMarker.content = getNewPin(markerInfo.Marker, true);
                    // Mark the current marker as selected
                    markerInfo.IsSelected = true;
                };
                const attachMarkerClickEvent = (markerInfo) => {
                    markerInfo.MapsMarker.addListener('click', ({ domEvent, latLng }) => {
                        eXpress.html.querySelectorAll(document, ".technical-select-store").forEach((e) => {
                            e.classList.remove("m-address-tile--active");
                            if (e.dataset.indx && +e.dataset.indx === markerInfo.Marker.Index) {
                                e.classList.add("m-address-tile--active");
                                if (e.parentElement)
                                    e.scrollIntoView({ behavior: "smooth" });
                                setMarkerContent(markerInfo);
                            }
                        });
                    });
                };
                const getNewPin = (marker, isLarge) => {
                    const baseWidth = 22;
                    const baseHeight = 33;
                    const height = baseHeight * (isLarge ? 1.7 : 1);
                    const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" height="' + height + '" viewBox="0 0 ' + baseWidth + ' ' + baseHeight + '"><path fill="' + marker.Color + '" d="M7.332 11.232c0 2.016 1.632 3.648 3.642 3.648 2.016 0 3.654-1.632 3.654-3.648S12.996 7.584 10.98 7.584 7.332 9.216 7.332 11.232Zm3.642 21.87s-.006.018-.006.018S.45 16.98.45 11.676C.45 3.87 5.778.474 10.974.462 16.17.474 21.498 3.87 21.498 11.676c0 5.304-10.512 21.444-10.512 21.444s-.012-.012-.012-.018Z" /></svg>';
                    const parser = new DOMParser();
                    const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;
                    return pinSvg;
                };
                const showMarker = (marker) => {
                    addMarkerToMap(marker);
                    const markerInfo = markerInfos.filter(m => m.Marker.Index === marker.Index)[0];
                    if (markerInfo)
                        setMarkerContent(markerInfo);
                };
                const addMarkerToMap = (marker) => {
                    if (!marker.Latitude
                        || !marker.Longitude
                        || isInError) {
                        return;
                    }
                    //Not yet initialize, delay by 500ms and try again
                    if (!isInitialized) {
                        setTimeout(() => { addMarkerToMap(marker); }, 500);
                        return;
                    }
                    let currentMarkerInfo = markerInfos.filter(m => m.Marker.Index === marker.Index)[0];
                    if (!currentMarkerInfo) {
                        currentMarkerInfo = {
                            MapsMarker: new google.maps.marker.AdvancedMarkerElement({
                                map: googleMapEl,
                                position: new google.maps.LatLng(marker.Latitude, marker.Longitude),
                                content: getNewPin(marker, false),
                                gmpClickable: true,
                            }),
                            Marker: marker,
                            IsSelected: false,
                        };
                        attachMarkerClickEvent(currentMarkerInfo);
                        markerInfos.push(currentMarkerInfo);
                    }
                };
                const initializeMap = () => {
                    googleMapEl = new google.maps.Map(containerEl, {
                        zoom: 12,
                        center: new google.maps.LatLng(0, 0),
                        scrollwheel: true,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        streetViewControl: false,
                        mapTypeControl: false,
                        mapId: mapId // Map ID is required for advanced markers.
                    });
                    if (mapRecentered) {
                        googleMapEl.addListener("center_changed", eXpress.utils.debounce(triggerMapCentered, 200));
                    }
                    isInitialized = true;
                };
                const triggerMapCentered = () => {
                    if (!mapRecentered || disableMapRecenter) {
                        return;
                    }
                    const center = googleMapEl.getCenter();
                    if (!center) {
                        return;
                    }
                    const latitude = center.lat();
                    const longitude = center.lng();
                    if (currentMapCenter.latitude != latitude || currentMapCenter.longitude != longitude) {
                        mapRecentered(center.lat(), center.lng());
                        currentMapCenter = { latitude, longitude };
                    }
                };
                const init = () => {
                    // The script is either loaded already (popup opened before) or not
                    // libraries=marker => enable AdvancedMarkers
                    const src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&libraries=marker";
                    if (!document.querySelector('script[src="' + src + '"]')) {
                        // It's not loaded ... Wait for load & then continue the init!
                        loadScript(src).then(() => initializeMap()).fail(() => isInError = true);
                    }
                    else {
                        initializeMap();
                    }
                };
                const loadScript = (url) => {
                    const deferred = $.Deferred();
                    // Create script element and set attributes
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.defer = true;
                    script.src = url;
                    // Append the script to the DOM
                    const firstScriptEl = document.getElementsByTagName('script')[0];
                    firstScriptEl.parentElement.insertBefore(script, firstScriptEl);
                    // Resolve the promise once the script is loaded
                    script.addEventListener('load', () => {
                        deferred.resolve();
                    });
                    // Catch any errors while loading the script
                    script.addEventListener('error', () => {
                        deferred.reject();
                    });
                    return deferred.promise();
                };
                const deInit = () => {
                    // empty
                };
                init();
                return {
                    createMarker: (marker) => addMarkerToMap(marker),
                    clearMarkers,
                    showMarker,
                    centerMap,
                    dispose: deInit
                };
            }
            checkout.createGoogleMap = createGoogleMap;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            class MiniBasket {
                constructor(miniBasketEl, deps) {
                    this.collapsableInfos = [];
                    this.miniBasketEl = miniBasketEl;
                    this.deps = deps;
                    this.addHandlers();
                }
                getTechClass(el) {
                    let found = "";
                    el.classList.forEach(className => {
                        if (className.includes("technical-")) {
                            found = className;
                        }
                    });
                    return found;
                }
                addHandlers() {
                    const collapsableEls = eXpress.html.querySelectorAll(this.miniBasketEl, '.m-collapsable');
                    if (collapsableEls) {
                        collapsableEls.forEach(collapsableEl => {
                            const collapsableElTechClass = this.getTechClass(collapsableEl);
                            if (this.collapsableInfos.filter(arrEl => arrEl.techClass === collapsableElTechClass).length === 0) {
                                this.collapsableInfos.push({ techClass: collapsableElTechClass, el: collapsableEl, titleSelector: '.m-collapsable__title', collapsable: undefined, shouldReopen: false });
                            }
                        });
                    }
                    this.collapsableInfos.forEach(c => {
                        var _a;
                        const el = eXpress.html.querySelector(this.miniBasketEl, '.' + c.techClass, false);
                        if (el) {
                            (_a = c.collapsable) === null || _a === void 0 ? void 0 : _a.dispose();
                            c.collapsable = components.main.createCollapsable(el, { titleElSelector: c.titleSelector, scrollIntoViewAfterOpen: false });
                            if (c.shouldReopen)
                                c.collapsable.open();
                        }
                    });
                }
                refreshServerSide(overrideMiniBasketHtml) {
                    if (overrideMiniBasketHtml) {
                        this.replaceHtml(overrideMiniBasketHtml);
                        return;
                    }
                    if (!this.deps.refreshMiniBasketApi)
                        return;
                    this.deps.refreshMiniBasketApi().then(res => {
                        this.replaceHtml(res.NewMiniBasketHtml);
                    });
                }
                replaceHtml(htmlString) {
                    const node = eXpress.html.htmlToElement(htmlString);
                    if (!node)
                        return;
                    // check if a collapsable should be reopened
                    this.collapsableInfos.forEach(c => {
                        var _a;
                        let shouldReopen = ((_a = c.collapsable) === null || _a === void 0 ? void 0 : _a.isOpen()) || false;
                        if (!shouldReopen) {
                            if (c.el)
                                shouldReopen = c.el.dataset.collapsedConfig === 'true';
                        }
                        c.shouldReopen = shouldReopen;
                    });
                    this.miniBasketEl.replaceWith(node);
                    this.miniBasketEl = node;
                    this.addHandlers();
                }
            }
            checkout.MiniBasket = MiniBasket;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
/*Styleguide organism: http://brandplatform.smartphoto.com/general/organisms/orders/ */
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createOrders(containerEl, deps) {
                const orderCount = +(containerEl.dataset.ordercount || 10);
                const selectedOrderNumber = eXpress.utils.getParameter("ordernumber");
                const { getOrderItemAsync, openTrailDialog } = deps;
                const createCollapsables = (collapseEls) => {
                    let counter = 0;
                    return collapseEls.map(el => {
                        counter++;
                        const orderId = el.dataset.orderid;
                        const orderNumber = el.dataset.ordernumber;
                        const onBeforeOpen = () => {
                            const contentEl = eXpress.html.querySelector(el, ".technical-collapse-content", true);
                            if (contentEl.innerHTML.indexOf("m-order-tile") !== -1)
                                return $.Deferred().resolve().promise();
                            return getOrderItemAsync(orderId)
                                .then(res => {
                                if (res.redirectUrl) {
                                    document.location.href = res.redirectUrl;
                                }
                                else {
                                    contentEl.insertAdjacentHTML("beforeend", res.content);
                                    init1Order(eXpress.html.querySelector(contentEl, ".technical-order-details", true));
                                }
                            });
                        };
                        const onBeforeClose = () => {
                            if (counter === 1)
                                eXpress.analytics.trackOrderStatusEvent('FirstTabClose', { orderNumber }, orderCount);
                            return $.Deferred().resolve().promise();
                        };
                        const collapsable = eXpress.components.main.createCollapsable(el, {
                            onBeforeOpen,
                            onBeforeClose,
                            scrollIntoViewAfterOpen: true,
                            titleElSelector: '.technical-collapsable-title'
                        });
                        collapsable.orderNumber = orderNumber;
                        collapsable.isOldOrder = eXpress.html.hasClass(el, 'technical-older-order');
                        return collapsable;
                    });
                };
                const init1Order = (orderDetails) => {
                    const isConsolidated = orderDetails.classList.contains('technical-consolidated-order');
                    const orderNumber = orderDetails.dataset.ordernumber || '';
                    // Enable trail buttons when the order opens
                    const trailDialogButtons = eXpress.html.querySelectorAll(orderDetails, ".technical-trail-dialog");
                    trailDialogButtons.forEach(el => el.addEventListener('click', (ev) => {
                        ev.preventDefault();
                        openTrailDialog(ev);
                        eXpress.analytics.trackOrderStatusEvent("TrailDialogOpen", { orderNumber, orderStatus: el.dataset.status, paymentStatus: el.dataset.paid, pvc: el.dataset.pvc });
                    }));
                    // Enable some events tracking
                    const pdfLink = eXpress.html.querySelector(orderDetails, '.technical-orderpdf-download');
                    if (pdfLink)
                        pdfLink.addEventListener('click', (ev) => eXpress.analytics.trackOrderStatusEvent(isConsolidated ? "ConsolidatedOrderPDFDownload" : "OrderPDFDownload", { orderNumber }));
                    const creditnoteLinks = eXpress.html.querySelectorAll(orderDetails, '.technical-creditnotepdf-download');
                    creditnoteLinks.forEach(link => link.addEventListener('click', (ev) => eXpress.analytics.trackOrderStatusEvent(isConsolidated ? "ConsolidatedCreditPDFDownload" : "CreditPDFDownload", { orderNumber })));
                    eXpress.html.inViewTrigger(orderDetails, () => {
                        eXpress.analytics.trackOrderStatusEvent("OrderDetailsRead", { orderNumber });
                    });
                    const paymentDetailsEl = eXpress.html.querySelector(orderDetails, '.technical-payment-details', false);
                    if (paymentDetailsEl) {
                        eXpress.html.inViewTrigger(paymentDetailsEl, () => {
                            eXpress.analytics.trackOrderStatusEvent("PaymentDetailsRead", { orderNumber });
                        });
                    }
                    const ttLinks = eXpress.html.querySelectorAll(orderDetails, '.technical-tracktrace');
                    ttLinks.forEach(link => link.addEventListener('click', (ev) => {
                        let orderStatus = '';
                        let pvc = '';
                        const parent = eXpress.html.getParentWithClassName(link, "technical-order-item-tile");
                        if (parent) {
                            const trailButton = eXpress.html.querySelector(parent, '.technical-trail-dialog', false);
                            if (trailButton) {
                                orderStatus = trailButton.dataset.status || '';
                                pvc = trailButton.dataset.pvc || '';
                            }
                        }
                        eXpress.analytics.trackOrderStatusEvent("TrackTraceClick", { orderNumber, orderStatus, pvc: pvc });
                    }));
                    const voucherLinks = eXpress.html.querySelectorAll(orderDetails, '.technical-voucher');
                    voucherLinks.forEach(link => link.addEventListener('click', (ev) => {
                        let orderStatus = '';
                        let pvc = '';
                        const parent = eXpress.html.getParentWithClassName(link, "technical-order-item-tile");
                        if (parent) {
                            const trailButton = eXpress.html.querySelector(parent, '.technical-trail-dialog', false);
                            if (trailButton) {
                                orderStatus = trailButton.dataset.status || '';
                                pvc = trailButton.dataset.pvc || '';
                            }
                        }
                        eXpress.analytics.trackOrderStatusEvent("VoucherDownload", { orderNumber, orderStatus, pvc: pvc });
                    }));
                };
                const toggleOlderOrders = (show) => collapsables.filter(c => c.isOldOrder)
                    .forEach(c => show ? c.show() : c.hide());
                const createOlderButton = () => {
                    const buttonEl = eXpress.html.querySelector(containerEl, ".technical-show-older-button", true);
                    const hideLabel = buttonEl.dataset.hideLabel || "";
                    const showLabel = buttonEl.textContent || "";
                    let olderShown = false;
                    const toggleButton = () => {
                        olderShown = !olderShown;
                        buttonEl.innerText = olderShown ? hideLabel : showLabel;
                        eXpress.analytics.trackOrderStatusEvent(olderShown ? 'OlderOrdersShow' : 'OlderOrdersHide', {}, orderCount);
                        toggleOlderOrders(olderShown);
                    };
                    buttonEl.addEventListener('click', toggleButton);
                    return {
                        dispose: () => buttonEl.removeEventListener('click', toggleButton),
                        toggleButton
                    };
                };
                // init component
                const collapsables = createCollapsables(eXpress.html.querySelectorAll(containerEl, ".m-collapsable"));
                // always show newer
                collapsables
                    .filter(c => !c.isOldOrder)
                    .forEach(c => c.show());
                const olderButton = collapsables.some(o => o.isOldOrder || false) && createOlderButton();
                if (selectedOrderNumber) {
                    collapsables.forEach(c => c.close());
                    const selected = collapsables.filter(c => (c.orderNumber) ? c.orderNumber.toLowerCase() === selectedOrderNumber.toLowerCase() : false)[0];
                    if (selected.isOldOrder) {
                        olderButton && olderButton.toggleButton();
                    }
                    selected.open(true);
                }
                // when opened , load the details
                const alreadyLoadedContent = eXpress.html.querySelectorAll(containerEl, ".technical-order-details");
                alreadyLoadedContent.forEach((el) => { init1Order(el); });
                // No orders events tracking
                const noOrders = eXpress.html.querySelector(containerEl, '.technical-no-orders', false);
                if (noOrders)
                    eXpress.html.inViewTrigger(noOrders, (element) => {
                        eXpress.analytics.trackOrderStatusEvent("NoOrdersRead", {});
                    });
                return {
                    dispose: () => {
                        collapsables.map(c => c.dispose());
                        olderButton && olderButton.dispose();
                    }
                };
            }
            checkout.createOrders = createOrders;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
// Component for organism:
// http://brandplatform.smartphoto.com/general/organisms/checkout-step#perosnal-data-step
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            // comprises of loginsection  + personal data form
            function createPersonalData(containerEl, deps) {
                const sameAddressEl = eXpress.html.querySelector(containerEl, '.technical-same-address', false);
                const { getZipCodeDefinitionAsync, getCitiesForCountryCodeAndSearchTerm, getGetCitiesByZipCode, submitPersonalData, showTopMessage, hideTopMessage, showAccountSoftDeletedPopup, onDirtyNavigateAway } = deps;
                const formEl = eXpress.html.querySelector(containerEl, '.technical-personal-data', true);
                /*const deliveryAddressSectionEl = html.querySelector<HTMLElement>(formEl, '#technical-delivery-address', false);
                const billingAddressSectionEl = html.querySelector<HTMLElement>(formEl, '#technical-billing-address', false);*/
                const companyCheck = eXpress.html.querySelector(formEl, '.technical-company', false);
                const advantageListEl = eXpress.html.querySelector(containerEl, '.technical-advantages-list', false);
                const passwordFormInput = eXpress.html.querySelector(formEl, '.technical-password', false);
                const createAdvantagesAnimation = (listItem) => {
                    const advantageListItemEls = eXpress.html.querySelectorAll(listItem, 'li');
                    let currentIndex = 0;
                    const displayTime = 2000;
                    const transitionTime = 1000;
                    const showNextItem = () => {
                        const prevIndex = (currentIndex - 1 + advantageListItemEls.length) % advantageListItemEls.length;
                        // hide previous item
                        advantageListItemEls[prevIndex].style.opacity = "0";
                        // show current item
                        const currentItem = advantageListItemEls[currentIndex];
                        currentItem.style.opacity = "1";
                        // prepare next item
                        currentIndex = (currentIndex + 1) % advantageListItemEls.length;
                        setTimeout(() => {
                            showNextItem();
                        }, displayTime + transitionTime); // wait until fade out and display are finished
                    };
                    // Initialisation: hide all
                    advantageListItemEls.forEach((el) => {
                        el.style.opacity = "0";
                    });
                    // Start animation
                    showNextItem();
                };
                const onSubmit = (formData) => {
                    // convert form data (keys are in lowercase !!)
                    const billingAddress = {};
                    let deliveryAddress = {};
                    const keys = Object.keys(formData);
                    for (let i = 0, l = keys.length; i < l; i++) {
                        const key = keys[i];
                        if (key.match('billingaddress')) {
                            billingAddress[key.replace('billingaddress', '')] = formData[key];
                        }
                        else if (key.match('deliveryaddress')) {
                            deliveryAddress[key.replace('deliveryaddress', '')] = formData[key];
                        }
                    }
                    // On spector we do not show the show delivery address toggle. Because we don't want failing validation on delivery address (always empty or set on profile) => copy billing in delivery
                    if (!sameAddressEl || (sameAddressEl && sameAddressEl.checked))
                        deliveryAddress = billingAddress;
                    // Manually clear the password because autocomplete fills the password input even when it is not visible => guest flow
                    let password = formData['password'];
                    if (passwordFormInput && eXpress.html.hasClass(passwordFormInput, "u-hide")) {
                        password = '';
                    }
                    const convertedFormData = {
                        BillingAddress: Object.keys(billingAddress).length !== 0 ? billingAddress : null,
                        DeliveryAddress: Object.keys(deliveryAddress).length !== 0 ? deliveryAddress : null,
                        MobileNumber: formData['mobilenumber'] || '',
                        Password: password ? eXpress.utils.stringToBase64(password) : '',
                        Email: formData['email'] || '',
                        PersonalNumber: formData['personalnumber'] || '',
                        VatNumber: companyCheck && companyCheck.checked ? formData['vatnumber'] || '' : '',
                        CompanyName: companyCheck && companyCheck.checked ? formData['companyname'] || '' : '',
                        FirstName: formData['firstname'] || '',
                        LastName: formData['lastname'] || '',
                        IsCompany: companyCheck && companyCheck.checked || false,
                        __RequestVerificationToken: formData['__RequestVerificationToken'] || '',
                    };
                    // submit data
                    submitPersonalData(convertedFormData)
                        .then(res => {
                        if (res.redirectUrl) {
                            window.location.href = res.redirectUrl;
                            return eXpress.utils.wait(99999);
                        }
                        res.softDelete && showAccountSoftDeletedPopup(convertedFormData, (name, error) => personalDataForm.setErrors(false, { name, error }), "/cart/personaldata");
                        res.blockingErrorMessage && showTopMessage(components.main.PageLogStyle.Error, res.blockingErrorMessage);
                        res.errorMessage && personalDataForm.setErrors(false, { name: res.errorMessage.name, error: res.errorMessage.message });
                        return $.Deferred().resolve().promise();
                    });
                    return $.Deferred().resolve().promise();
                };
                const personalDataForm = createPersonalDataForm(formEl, {
                    onSubmit: formData => eXpress.utils.showLoadingDialog(onSubmit(formData)),
                    getZipCodeDefinitionAsync,
                    getCitiesForCountryCodeAndSearchTerm,
                    getGetCitiesByZipCode,
                    alternativeSubmitButtonEl: eXpress.html.querySelector(containerEl, '.technical-personal-data-submit', true),
                    hideTopMessage,
                    showTopMessage,
                    updateCountryText: false,
                    onDirtyNavigateAway
                });
                advantageListEl && createAdvantagesAnimation(advantageListEl);
                return {
                    updatePersonalDataForm: (accountData) => personalDataForm.updateWithAccountData(accountData),
                    finishPersonalDataInlineLogin: (data) => {
                        personalDataForm.fillFormData(data);
                    },
                    showRegisterSection: () => { personalDataForm.showRegisterSection(); },
                    showGuestSection: () => { personalDataForm.showGuestSection(); },
                    hideForm: () => { personalDataForm.hideForm(); },
                    showForm: () => { personalDataForm.showForm(); }
                };
            }
            checkout.createPersonalData = createPersonalData;
            // personal data form  + addressSection
            function createPersonalDataForm(formEL, deps) {
                const privateCheck = eXpress.html.querySelector(formEL, '.technical-private', false);
                const companyCheck = eXpress.html.querySelector(formEL, '.technical-company', false);
                const sameAddressEl = eXpress.html.querySelector(formEL, '.technical-same-address', false);
                const companynameDivEl = eXpress.html.querySelector(formEL, '.technical-company-name', false);
                const deliveryAddress = eXpress.html.querySelector(formEL, '#technical-delivery-address', false);
                const billingAddress = eXpress.html.querySelector(formEL, '#technical-billing-address', false);
                const titleEl = eXpress.html.querySelector(formEL, '.technical-billing-address-title', false);
                const title = (titleEl === null || titleEl === void 0 ? void 0 : titleEl.textContent) || '';
                const addressId = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.dataset.id;
                const popupCase = addressId == '00000000-0000-0000-0000-000000000000' ? AddressComponentCases.Create : AddressComponentCases.Edit;
                const address = formEL.id === 'technical-address' ? formEL : eXpress.html.querySelector(formEL, '#technical-address', false);
                const companyVatNumberDivEl = eXpress.html.querySelector(formEL, '.technical-company-vat-number', false);
                const orderAsCompanyMessage = formEL.dataset.orderAsCompanyMessage || '';
                const showOrderAsCompanyMessage = formEL.dataset.showOrderAsCompanyMessage === 'true' || false;
                let companyChecked = companyCheck && companyCheck.checked;
                let billingAddressSection;
                let deliveryAddressSection;
                let addressSection;
                const eventDisposables = eXpress.utils.compositeDisposable([]);
                const { onSubmit, getZipCodeDefinitionAsync, getCitiesForCountryCodeAndSearchTerm, getGetCitiesByZipCode, alternativeSubmitButtonEl, hideTopMessage, showTopMessage, updateCountryText, onDirtyNavigateAway } = deps;
                const onSameAddressClick = () => {
                    deliveryAddress && deliveryAddress.classList.toggle('u-hide');
                    if (!titleEl)
                        return;
                    const fallbackTitle = titleEl.dataset.fallbacktitle || '';
                    if (!title || !fallbackTitle)
                        return;
                    titleEl.textContent = titleEl.textContent === fallbackTitle
                        ? title
                        : fallbackTitle;
                };
                const onCompanyCheckClick = () => {
                    if (companyCheck && companyCheck.checked && !companyChecked) {
                        companynameDivEl && companynameDivEl.classList.toggle('u-hide');
                        companyVatNumberDivEl && companyVatNumberDivEl.classList.toggle('u-hide');
                        companyChecked = true;
                        const defaultRegionCode = formEL.dataset.defaultCountry || formEL.dataset.defaultRegions || '';
                        let selectedDeliveryRegionCode, selectedBillingRegionCode = '';
                        if (addressSection)
                            addressSection.updateCountry(defaultRegionCode, true);
                        if (deliveryAddressSection) {
                            selectedDeliveryRegionCode = deliveryAddressSection.getCurrentRegionCode();
                            deliveryAddressSection.updateCountry(defaultRegionCode, true);
                        }
                        if (billingAddressSection) {
                            selectedBillingRegionCode = billingAddressSection.getCurrentRegionCode();
                            billingAddressSection.updateCountry(defaultRegionCode, true);
                        }
                        if (showTopMessage && (defaultRegionCode !== selectedDeliveryRegionCode || defaultRegionCode !== selectedBillingRegionCode))
                            showTopMessage(components.main.PageLogStyle.WarningOrange, orderAsCompanyMessage);
                        personalDataForm.setErrors(true);
                    }
                };
                const onPrivateCheckClick = () => {
                    if (privateCheck && privateCheck.checked && companyChecked) {
                        companynameDivEl && companynameDivEl.classList.toggle('u-hide');
                        companyVatNumberDivEl && companyVatNumberDivEl.classList.toggle('u-hide');
                        companyChecked = false;
                        if (addressSection)
                            addressSection.disableCountry(false, true);
                        if (deliveryAddressSection)
                            deliveryAddressSection.disableCountry(false, true);
                        if (billingAddressSection)
                            billingAddressSection.disableCountry(false, true);
                        if (hideTopMessage)
                            hideTopMessage();
                        personalDataForm.setErrors(true);
                    }
                };
                if (eventDisposables && eventDisposables.add) {
                    if (sameAddressEl)
                        eventDisposables.add([eXpress.html.addEventListener(sameAddressEl, 'click', onSameAddressClick)]);
                    if (companyCheck)
                        eventDisposables.add([eXpress.html.addEventListener(companyCheck, 'change', onCompanyCheckClick)]);
                    if (privateCheck)
                        eventDisposables.add([eXpress.html.addEventListener(privateCheck, 'click', onPrivateCheckClick)]);
                }
                const personalDataForm = components.main.initForm(formEL, {
                    onSubmitForm: onSubmit,
                    alternativeButton: alternativeSubmitButtonEl,
                    submitOnEnter: true,
                    validatorOptions: { onValidate: hideTopMessage },
                    onDirtyNavigateAway
                });
                if (deliveryAddress) {
                    if (sameAddressEl)
                        window.onload = () => { deliveryAddress.classList.toggle('u-hide', sameAddressEl.checked); };
                    deliveryAddressSection = createAddressSection(deliveryAddress, popupCase, {
                        getZipCodeDefinitionAsync: getZipCodeDefinitionAsync,
                        updateCountryText: updateCountryText !== null && updateCountryText !== void 0 ? updateCountryText : true,
                        getCitiesForCountryCodeAndSearchTerm,
                        getGetCitiesByZipCode,
                        clearFormInput: name => personalDataForm.clearInputs(true, name),
                    }, 'deliveryAddress');
                }
                if (billingAddress) {
                    billingAddressSection = createAddressSection(billingAddress, popupCase, {
                        getZipCodeDefinitionAsync: getZipCodeDefinitionAsync,
                        updateCountryText: updateCountryText !== null && updateCountryText !== void 0 ? updateCountryText : true,
                        getCitiesForCountryCodeAndSearchTerm,
                        getGetCitiesByZipCode,
                        clearFormInput: name => personalDataForm.clearInputs(true, name)
                    }, 'billingAddress');
                }
                if (address) {
                    addressSection = createAddressSection(address, popupCase, {
                        getZipCodeDefinitionAsync: getZipCodeDefinitionAsync,
                        updateCountryText: updateCountryText !== null && updateCountryText !== void 0 ? updateCountryText : true,
                        getCitiesForCountryCodeAndSearchTerm,
                        getGetCitiesByZipCode,
                        clearFormInput: name => personalDataForm.clearInputs(true, name)
                    }, 'address');
                }
                const updateWithAccountData = (data) => {
                    const nameValues = [];
                    Object.keys(data).map(k => {
                        if (data[k]) {
                            nameValues.push({ name: k, value: data[k] });
                        }
                    });
                    personalDataForm.setValues(...nameValues);
                    personalDataForm.disableForm(false);
                    data['Email'] && personalDataForm.disableInput('email');
                };
                const fillFormData = (data, disableDefaultAddress, countryChangeEnabled) => {
                    const nameValues = [];
                    if (deliveryAddress && data.DeliveryAddress) {
                        fillAddress(data.DeliveryAddress, 'deliveryAddress', nameValues);
                        deliveryAddressSection.updateCountry(nameValues.filter(nv => nv.name === 'deliveryAddressCountryId')[0].value);
                    }
                    if (billingAddress && data.BillingAddress) {
                        fillAddress(data.BillingAddress, 'billingAddress', nameValues);
                        billingAddressSection.updateCountry(nameValues.filter(nv => nv.name === 'billingAddressCountryId')[0].value);
                    }
                    if (data.PersonalNumber)
                        nameValues.push({ name: 'PersonalNumber', value: data.PersonalNumber });
                    if (data.MobileNumber)
                        nameValues.push({ name: 'MobileNumber', value: data.MobileNumber });
                    if (data.Email)
                        nameValues.push({ name: 'Email', value: data.Email });
                    personalDataForm.setValues(...nameValues);
                    if (!addressSection)
                        personalDataForm.disableForm(false);
                    personalDataForm.disableInput('email');
                    if (!countryChangeEnabled) {
                        if (data.BillingAddress)
                            personalDataForm.disableInput("billingAddressCountryId");
                        if (data.DeliveryAddress)
                            personalDataForm.disableInput("deliveryAddressCountryId");
                    }
                    if (!data.BillingAddress && data.DeliveryAddress && data.DeliveryAddress.VatNumber && !addressSection)
                        personalDataForm.disableInput('VatNumber');
                    if (!data.BillingAddress && data.DeliveryAddress && data.DeliveryAddress.IsDefault || disableDefaultAddress)
                        personalDataForm.disableInput('DefaultAddress');
                    personalDataForm.hideInput('password');
                    if (data.PersonalNumber)
                        personalDataForm.hideInput('PersonalNumber');
                };
                const fillAddress = (address, prefix, nameValues) => {
                    Object.keys(address).map(k => {
                        if (address[k]) {
                            let alternateName = undefined;
                            // names not 1 on 1 with form
                            if (k.toLocaleLowerCase() === 'regioncountryiso'
                                || k.toLocaleLowerCase() === 'country') {
                                alternateName = "CountryId";
                            }
                            if (k.toLocaleLowerCase() === 'isdefault') {
                                nameValues.push({ name: 'DefaultAddress', value: address[k] });
                            }
                            else if (k.toLocaleLowerCase() === 'firstname' || k.toLocaleLowerCase() === 'lastname' || k.toLocaleLowerCase() === 'vatnumber' || k.toLocaleLowerCase() === 'companyname') {
                                if (address[k] && !nameValues[k])
                                    nameValues.push({ name: k, value: address[k] });
                            }
                            else {
                                nameValues.push({ name: prefix + (alternateName ? alternateName : k), value: address[k] });
                            }
                        }
                    });
                };
                if (showOrderAsCompanyMessage && orderAsCompanyMessage && showTopMessage)
                    showTopMessage(components.main.PageLogStyle.WarningOrange, orderAsCompanyMessage);
                const enableFormAndButton = () => {
                    eXpress.html.removeClass(formEL, "u-hide");
                    personalDataForm.enableButton();
                };
                const showRegisterSection = () => {
                    enableFormAndButton();
                    personalDataForm.showInput('password');
                    personalDataForm.setRequiredOnInput('password', true);
                };
                const showGuestSection = () => {
                    enableFormAndButton();
                    personalDataForm.hideInput('password');
                    personalDataForm.clearInputs(true, 'password');
                    personalDataForm.setRequiredOnInput('password', false);
                };
                return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, personalDataForm), deliveryAddressSection), billingAddressSection), addressSection), { fillFormData,
                    updateWithAccountData, dispose: () => {
                        personalDataForm.dispose();
                        deliveryAddressSection && deliveryAddressSection.dispose();
                        billingAddressSection && billingAddressSection.dispose();
                        addressSection && addressSection.dispose();
                        eventDisposables.dispose();
                    }, showRegisterSection,
                    showGuestSection, hideForm: () => { eXpress.html.addClass(formEL, "u-hide"); } });
            }
            checkout.createPersonalDataForm = createPersonalDataForm;
            let AddressComponentCases;
            (function (AddressComponentCases) {
                AddressComponentCases[AddressComponentCases["Edit"] = 0] = "Edit";
                AddressComponentCases[AddressComponentCases["Create"] = 1] = "Create";
            })(AddressComponentCases || (AddressComponentCases = {}));
            const createAddressSection = (addressSectionEl, popupCase, deps, prefix) => {
                const { getZipCodeDefinitionAsync, updateCountryText, getCitiesForCountryCodeAndSearchTerm, getGetCitiesByZipCode, clearFormInput, } = deps;
                const countrySelectBoxEl = eXpress.html.querySelector(addressSectionEl, `#${prefix ? prefix : ''}CountryId`, true);
                const zipCodeInputEl = eXpress.html.querySelector(addressSectionEl, `#${prefix ? prefix : ''}ZipCode`, true);
                const cityInputEl = eXpress.html.querySelector(addressSectionEl, `#${prefix ? prefix : ''}City`, true);
                const citiesSelectEl = eXpress.html.querySelector(addressSectionEl, `#${prefix ? prefix : ''}Cities`, true);
                const cityRemoveButtonEl = eXpress.html.querySelector(addressSectionEl, '.technical-remove-city-selection', true);
                const defaultRegions = addressSectionEl.dataset.defaultRegions || '';
                const deliveryAbroadEnabled = addressSectionEl.dataset.deliveryAbroadEnabled ? addressSectionEl.dataset.deliveryAbroadEnabled === "true" : true;
                let cityInputElWithAutoComplete;
                let firstZipCheck = popupCase === AddressComponentCases.Edit;
                let previousZip = '-1';
                const findZipCodeFromSelect = true;
                const toggleCitySelectControl = (show) => {
                    eXpress.html.toggleClass(eXpress.html.getParentWithClassName(citiesSelectEl, 'a-form-input'), 'u-hide', !show);
                    eXpress.html.toggleClass(eXpress.html.getParentWithClassName(cityInputEl, 'a-form-input'), 'u-hide', show);
                    eXpress.html.toggleClass(cityRemoveButtonEl, 'u-hide', !show);
                    citiesSelectEl.removeAttribute("required");
                    cityInputEl.removeAttribute("required");
                    show
                        ? citiesSelectEl.setAttribute("required", "required")
                        : cityInputEl.setAttribute("required", "required");
                };
                const resetCityControls = () => {
                    const prefix = 'deliveryaddress';
                    clearFormInput(`${prefix}city`);
                    clearFormInput(`${prefix}cities`);
                    // always show text
                    toggleCitySelectControl(false);
                };
                const onZipCodeKey = (fromSelect) => {
                    const regexp = zipCodeInputEl.getAttribute('regex');
                    const value = zipCodeInputEl.value;
                    const currentCity = cityInputEl.value;
                    let selectedIndex = -1;
                    if (!value || (previousZip === value && !fromSelect) || !regexp || !new RegExp(regexp).test(value))
                        return;
                    previousZip = value;
                    getGetCitiesByZipCode(value, currentSelectedCountry).then(res => {
                        if (res && res.length) {
                            citiesSelectEl.innerHTML = '';
                            res.forEach((city, index) => {
                                const option = document.createElement('option');
                                option.value = city;
                                option.innerHTML = city;
                                citiesSelectEl.appendChild(option);
                                if (city.toLowerCase() == currentCity.toLowerCase())
                                    selectedIndex = index;
                            });
                        }
                        if (selectedIndex > -1)
                            citiesSelectEl.selectedIndex = selectedIndex;
                        if (firstZipCheck && selectedIndex < 0) {
                            firstZipCheck = false;
                        }
                        else {
                            if (firstZipCheck)
                                firstZipCheck = false;
                            cityInputEl.value = (selectedIndex > -1 && currentCity) || (res && res[0] && res[0]) || currentCity;
                            toggleCitySelectControl(res && res.length > 0);
                        }
                    });
                };
                let currentSelectedCountry = countrySelectBoxEl.value;
                const updateCountryAsync = (regionCode, disable = false, resetOptions = false, overrideDefaultRegions = '') => {
                    countrySetDisabled(false); // => if not we can't update the selected country
                    if (regionCode && regionCode !== currentSelectedCountry) {
                        if (countrySelectBoxEl.value !== regionCode)
                            countrySelectBoxEl.value = regionCode;
                        currentSelectedCountry = regionCode;
                        disable && countrySetDisabled(disable, resetOptions, overrideDefaultRegions);
                        let disableSetAsDefault = false;
                        if (overrideDefaultRegions)
                            disableSetAsDefault = !deliveryAbroadEnabled && overrideDefaultRegions.indexOf(currentSelectedCountry) !== -1;
                        else
                            disableSetAsDefault = !deliveryAbroadEnabled && defaultRegions.indexOf(currentSelectedCountry) !== -1;
                        return getZipCodeDefinitionAsync(regionCode)
                            .then(res => res && updateAddressSection(res, disableSetAsDefault, true));
                    }
                    else {
                        disable && countrySetDisabled(disable, resetOptions, overrideDefaultRegions);
                        return $.Deferred().resolve().promise();
                    }
                };
                const onCountrySelectedChange = () => {
                    currentSelectedCountry = countrySelectBoxEl.options[countrySelectBoxEl.selectedIndex].value;
                };
                const getSelectedCountry = () => {
                    return currentSelectedCountry;
                };
                const updateAddressSection = (def, disableSetAsDefault, clearInputs) => {
                    const inputEls = eXpress.html.querySelectorAll(addressSectionEl, 'input').filter(el => el.name.toLowerCase() !== "deliveryaddressfirstname" && el.name.toLowerCase() !== "deliveryaddresslastname");
                    if (clearInputs)
                        clearAddressSection(inputEls);
                    const countryInputEl = eXpress.html.querySelector(document, '#' + (prefix ? prefix : '') + 'CountryId', false);
                    if (updateCountryText && countryInputEl)
                        updateAddressSelect(countryInputEl, def);
                    // search zip code in inputEls
                    const zipcodeInputEl = inputEls.find(x => x.id === ((prefix ? prefix : '') + 'ZipCode'));
                    if (zipcodeInputEl) {
                        if (prefix && prefix === 'deliveryAddress')
                            zipcodeInputEl.setAttribute("blacklist", def.BlackListedZipCodes);
                        updateAddressInput(zipcodeInputEl, def);
                        if (countryInputEl)
                            zipcodeInputEl.setAttribute('format-example', countryInputEl.value === 'SWE' && def.ExampleZipCodeOfRegion ? def.ExampleZipCodeOfRegion : '');
                    }
                    setPlaceholder(inputEls, prefix, 'ZipCode', def.LabelPlaceHolder);
                    toggleCitySelectControl(false);
                    citiesSelectEl.value = '';
                    disableDefaultAddressInputElement(inputEls.filter(el => el.id === "DefaultAddress")[0], disableSetAsDefault);
                };
                const setPlaceholder = (inputEls, prefix, key, val) => {
                    const inputEl = inputEls.find(x => x.id === ((prefix ? prefix : '') + key));
                    if (inputEl) {
                        inputEl.setAttribute('placeholder', val !== null && val !== void 0 ? val : "");
                    }
                };
                const disableDefaultAddressInputElement = (el, disable) => {
                    if (el) {
                        const parent = eXpress.html.getParentWithClassName(el, "a-form-input");
                        if (disable) {
                            el.disabled = true;
                            el.checked = false;
                            parent && parent.classList.add("a-form-input--disabled");
                        }
                        else {
                            el.disabled = false;
                            parent && parent.classList.remove("a-form-input--disabled");
                        }
                    }
                };
                const clearAddressSection = (inputEls, clearNames = false) => inputEls.map(el => {
                    if (clearNames)
                        clearFormInput(el.id.toLowerCase());
                    else if (!el.id.toLowerCase().includes('firstname') && !el.id.toLowerCase().includes('lastname')) {
                        clearFormInput(el.id.toLowerCase());
                    }
                });
                const updateAddressSelect = (selectEl, rule) => {
                    if (rule) {
                        Object.keys(rule)
                            .forEach(key => addOrRemoveRulesToSelect(selectEl, key.toLowerCase(), rule[key]));
                    }
                };
                const updateAddressInput = (inputEl, rule) => {
                    if (rule) {
                        Object.keys(rule)
                            .forEach(key => addOrRemoveRulesToInput(inputEl, key.toLowerCase(), rule[key]));
                    }
                };
                const addAutoCompleteToInputEl = (el) => {
                    return components.main.createTextInputWithAutoComplete(el, {
                        autoCompleteSearch: (term) => getCitiesForCountryCodeAndSearchTerm(term, currentSelectedCountry)
                            .then(res => res.map(x => ({ value: x.zipcode, label: x.name }))),
                        onSelect: (item) => {
                            item.value && (zipCodeInputEl.value = item.value);
                            if (item.value)
                                onZipCodeKey(findZipCodeFromSelect);
                        },
                        preventSubmit: true,
                    });
                };
                const addOrRemoveRulesToSelect = (el, ruleName, ruleValue) => {
                    const inputContainerEl = el.parentElement;
                    const infoTextEl = eXpress.html.querySelector(inputContainerEl, '.a-form-input__info-text');
                    switch (ruleName.toLowerCase()) {
                        case 'nodeliverypossible':
                            if (infoTextEl)
                                infoTextEl.innerHTML = ruleValue ? ruleValue.toString() : "";
                            break;
                        default:
                            break;
                    }
                    infoTextEl && infoTextEl.textContent
                        ? eXpress.html.removeClass(infoTextEl, 'u-hide')
                        : infoTextEl && eXpress.html.addClass(infoTextEl, 'u-hide');
                };
                const addOrRemoveRulesToInput = (el, ruleName, ruleValue) => {
                    const inputContainerEl = el.parentElement;
                    const labelEl = eXpress.html.querySelector(inputContainerEl, '.a-form-input__label');
                    const infoTextEl = eXpress.html.querySelector(inputContainerEl, '.a-form-input__info-text');
                    switch (ruleName.toLowerCase()) {
                        case 'maxlength':
                        case 'regex':
                        case 'autocomplete':
                        case 'mandatory':
                            ruleValue ? el.setAttribute(ruleName, ruleName === "autocomplete" ? `shipping ${ruleValue.toString()}` : ruleValue.toString()) : el.removeAttribute(ruleName);
                            break;
                        case 'label':
                            if (labelEl)
                                labelEl.innerHTML = ruleValue.toString();
                            break;
                        case 'labelplaceholder':
                            el.setAttribute('placeholder', ruleValue.toString());
                            break;
                        case 'example':
                        case 'examplezipcode':
                            if (infoTextEl)
                                infoTextEl.innerHTML = ruleValue ? ruleValue.toString() : "";
                            break;
                        case 'zipcodesuggestions':
                            if (!el)
                                break;
                            el.dataset.zipcodesuggestions = ruleValue ? ruleValue.toString() : "true";
                            cityInputElWithAutoComplete && cityInputElWithAutoComplete.dispose();
                            if (ruleValue.toString() === "true")
                                cityInputElWithAutoComplete = addAutoCompleteToInputEl(el);
                            break;
                        default:
                            break;
                    }
                    infoTextEl && infoTextEl.textContent
                        ? eXpress.html.removeClass(infoTextEl, 'u-hide')
                        : infoTextEl && eXpress.html.addClass(infoTextEl, 'u-hide');
                };
                // init country select box
                components.main.createSelectBox(countrySelectBoxEl.parentElement, (value) => updateCountryAsync(value || "", false, false));
                components.main.createSelectBox(citiesSelectEl.parentElement, (city) => cityInputEl.value = city || "");
                if (cityInputEl && cityInputEl.dataset.zipcodesuggestions && cityInputEl.dataset.zipcodesuggestions === "true") {
                    cityInputElWithAutoComplete = addAutoCompleteToInputEl(eXpress.html.querySelector(addressSectionEl, `#${prefix ? prefix : ''}City`, true));
                }
                const disposableEvents = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(zipCodeInputEl, 'keyup', () => { onZipCodeKey(!findZipCodeFromSelect); }),
                    eXpress.html.addEventListener(zipCodeInputEl, 'focusout', () => { onZipCodeKey(!findZipCodeFromSelect); }),
                    eXpress.html.addEventListener(cityRemoveButtonEl, 'click', resetCityControls),
                    eXpress.html.addEventListener(countrySelectBoxEl, 'change', onCountrySelectedChange)
                ]);
                const countrySetDisabled = (disabled, resetOptions = false, overrideDefaultRegions = '') => {
                    var _a, _b;
                    const regionsToCheck = overrideDefaultRegions || defaultRegions;
                    if (disabled) {
                        const parentEl = eXpress.html.getParentWithClassName(countrySelectBoxEl, 'a-form-input');
                        if (parentEl && parentEl.classList.contains('a-form-input--error'))
                            parentEl.classList.remove('a-form-input--error');
                        // If we have several default regions we can't disable the complete select but we have to hide the options that aren't allowed
                        if (regionsToCheck.indexOf("|") !== -1) {
                            for (let i = 0; i < countrySelectBoxEl.options.length; i++) {
                                const option = countrySelectBoxEl.options[i];
                                if (defaultRegions.indexOf(option.value) === -1) {
                                    option.hidden = true;
                                }
                            }
                        }
                        else {
                            countrySelectBoxEl.disabled = true;
                            (_a = countrySelectBoxEl.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('a-form-input--disabled');
                        }
                    }
                    else {
                        if (regionsToCheck.indexOf("|") !== -1 && resetOptions) {
                            for (let i = 0; i < countrySelectBoxEl.options.length; i++) {
                                const option = countrySelectBoxEl.options[i];
                                option.hidden = false;
                            }
                        }
                        else {
                            countrySelectBoxEl.disabled = false;
                            (_b = countrySelectBoxEl.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('a-form-input--disabled');
                        }
                    }
                };
                onZipCodeKey(!findZipCodeFromSelect);
                return {
                    dispose: () => {
                        resetCityControls();
                        disposableEvents.dispose();
                    },
                    updateCountry: updateCountryAsync,
                    disableCountry: countrySetDisabled,
                    getCurrentRegionCode: getSelectedCountry
                };
            };
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createPickDeliveryAddress(popupEl, deps) {
                const { setDefaultDeliveryAddressAsync, deliveryAddressPopup, removeDeliveryAddressConfirmationPopup, parentDialog, selectHomeDeliveryOption } = deps;
                const containerEl = eXpress.html.querySelector(popupEl, '.technical-pick-delivery-address-container', true);
                const buttonContainerEl = eXpress.html.querySelector(popupEl, '.technical-pick-delivery-address-button-container', true);
                const addressTileEls = eXpress.html.querySelectorAll(containerEl, '.technical-address-tile, .technical-default-address-tile');
                const disabledAddressTileEls = eXpress.html.querySelectorAll(containerEl, '.technical-address-tile-disabled');
                const editDeliveryAddressButtonEls = eXpress.html.querySelectorAll(containerEl, '.technical-edit-delivery-address-button');
                const deleteDeliveryAddressButtonEls = eXpress.html.querySelectorAll(containerEl, '.technical-delete-delivery-address-button');
                const addDeliveryAddressButtonEl = eXpress.html.querySelector(buttonContainerEl, '.technical-add-delivery-address-button', true);
                const onAddressTileClick = (ev, el) => {
                    const currentEl = ev.target;
                    if (!currentEl.classList.contains("technical-edit-delivery-address-button") &&
                        !currentEl.classList.contains("technical-delete-delivery-address-button")) {
                        const isDefaultAddressTile = eXpress.html.getParentWithClassName(currentEl, 'technical-default-address-tile');
                        if (!isDefaultAddressTile) {
                            const addressId = el.dataset.id ? el.dataset.id : "";
                            if (addressId) {
                                setDefaultDeliveryAddressAsync(addressId);
                            }
                        }
                        else {
                            selectHomeDeliveryOption();
                            parentDialog.close(true);
                        }
                    }
                };
                const onDisabledAddressTileClick = (ev, el) => {
                    const currentEl = ev.target;
                    if (!currentEl.classList.contains("technical-edit-delivery-address-button") && !currentEl.classList.contains("technical-delete-delivery-address-button")) {
                        ev.preventDefault();
                        return false;
                    }
                };
                const onAddAddressButtonClick = (ev) => {
                    deliveryAddressPopup(parentDialog);
                };
                const onDeleteAddressButtonClick = (ev) => {
                    const buttonEl = ev.target;
                    const addressTileEl = eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile')
                        || eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile-disabled');
                    if (addressTileEl) {
                        const addressId = addressTileEl.dataset.id ? addressTileEl.dataset.id : "";
                        if (addressId !== "")
                            removeDeliveryAddressConfirmationPopup(parentDialog, addressId);
                    }
                };
                const onEditAddressButtonClick = (ev) => {
                    const buttonEl = ev.target;
                    const isDisabled = eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile-disabled') !== null;
                    const addressTileEl = eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile')
                        || eXpress.html.getParentWithClassName(buttonEl, 'technical-default-address-tile')
                        || eXpress.html.getParentWithClassName(buttonEl, 'technical-address-tile-disabled');
                    if (addressTileEl) {
                        const countryChangeEnabled = addressTileEl.dataset.countryEnabled === "true";
                        deliveryAddressPopup(parentDialog, addressTileEl.dataset.id || "", isDisabled, countryChangeEnabled);
                    }
                };
                const init = () => {
                    addressTileEls.forEach(el => el.addEventListener('click', (ev) => onAddressTileClick(ev, el)));
                    disabledAddressTileEls.forEach(el => el.addEventListener('click', (ev) => onDisabledAddressTileClick(ev, el)));
                    editDeliveryAddressButtonEls.forEach(el => el.addEventListener('click', onEditAddressButtonClick));
                    deleteDeliveryAddressButtonEls.forEach(el => el.addEventListener('click', onDeleteAddressButtonClick));
                    addDeliveryAddressButtonEl.addEventListener('click', onAddAddressButtonClick);
                };
                const deInit = () => {
                    addressTileEls.forEach(el => el.removeEventListener("click", (ev) => onAddressTileClick(ev, el)));
                    disabledAddressTileEls.forEach(el => el.removeEventListener('click', (ev) => onDisabledAddressTileClick(ev, el)));
                    editDeliveryAddressButtonEls.forEach(el => el.removeEventListener('click', onEditAddressButtonClick));
                    deleteDeliveryAddressButtonEls.forEach(el => el.removeEventListener("click", onDeleteAddressButtonClick));
                    addDeliveryAddressButtonEl.removeEventListener("click", onAddAddressButtonClick);
                };
                init();
                return {
                    dispose: deInit
                };
            }
            checkout.createPickDeliveryAddress = createPickDeliveryAddress;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createPickupDelivery(popupEl, deps) {
                const { savePickupPointsAsync, searchPickupPoints, searchPickupPointsByCoordinates, changeCountryForPickupPointsAsync, getCitiesForCountryCodeAndSearchTerm, createMarker, showMarker, centerMap, clearMarkers, showTopMessage, pickupChangeAddress } = deps;
                const pickupFormEl = eXpress.html.querySelector(popupEl, 'form.technical-pickup-form', true);
                const pickupPointsListEl = eXpress.html.querySelector(popupEl, ".technical-pickuppoints", true);
                const pickupPointsContainer = eXpress.html.querySelector(popupEl, ".technical-map-container", true);
                const pickupPointsNoResultsEl = eXpress.html.querySelector(popupEl, ".technical-pickuppoints-noresult", true);
                let selectedCountry = pickupFormEl.dataset.countrycode ? pickupFormEl.dataset.countrycode : 'BEL';
                const selectPickUpLabel = pickupFormEl.getAttribute("data-pickup-select-label") || "Select a collection point";
                const zipCodeInputEl = eXpress.html.querySelector(pickupFormEl, "#ZipCode", true);
                const cityInputEl = eXpress.html.querySelector(pickupFormEl, '#City', true);
                let preselectedZipCode = zipCodeInputEl.value;
                const formComponent = components.main.initForm(pickupFormEl, {
                    onSubmitForm: (formData) => searchAndUpdatePickuppoints(formData['zipcode']),
                    validatorOptions: ({
                        shouldScrollToFirstError: true,
                        ignore: '.ignore'
                    })
                });
                const changeCountry = (e) => {
                    e.preventDefault();
                    const countryInputEl = e.currentTarget;
                    selectedCountry = countryInputEl.value;
                    changeCountryForPickups(selectedCountry, countryInputEl.options[countryInputEl.selectedIndex].getAttribute("data-searchtype") || undefined, countryInputEl.options[countryInputEl.selectedIndex].getAttribute("selected") || undefined);
                };
                const changeCountryForPickups = (selectedCountry, searchType, selected) => {
                    changeCountryForPickupPointsAsync(selectedCountry, searchType)
                        .then((res) => {
                        if (res) {
                            const showOnlyInSearchEls = eXpress.html.querySelectorAll(popupEl, ".technical-show-in-search");
                            if (res.showAsList)
                                showOnlyInSearchEls.forEach(el => el.classList.add("u-hide"));
                            else
                                showOnlyInSearchEls.forEach(el => el.classList.remove("u-hide"));
                            if (zipCodeInputEl) {
                                const zipCodeExampleEl = eXpress.html.querySelector(popupEl, ".technical-zipcode-exampletext", false);
                                if (zipCodeExampleEl && res.zipCodeExample)
                                    zipCodeExampleEl.innerHTML = res.zipCodeExample;
                                // visibility and checks zipcode
                                if ((zipCodeInputEl.parentElement && zipCodeInputEl.parentElement.classList.contains('u-hide')) || (zipCodeInputEl.classList.contains('u-hide'))) {
                                    zipCodeInputEl.removeAttribute('required');
                                    zipCodeInputEl.removeAttribute('maxlength');
                                    zipCodeInputEl.removeAttribute('regex');
                                    zipCodeInputEl.value = '';
                                }
                                else {
                                    zipCodeInputEl.setAttribute('required', 'required');
                                    zipCodeInputEl.setAttribute("regex", res.zipCodeRegex);
                                    if (selected && preselectedZipCode.match(res.zipCodeRegex))
                                        zipCodeInputEl.value = preselectedZipCode;
                                }
                            }
                            if (zipCodeInputEl && zipCodeInputEl.value && !res.showAsList) {
                                searchAndUpdatePickuppoints(zipCodeInputEl.value);
                            }
                            else {
                                updatePickupPointList(res.res, true);
                                attachEventAndMarkerForStoreToMap(true);
                            }
                        }
                        return res;
                    });
                };
                // still bad practice, rerendering large chunks of the dom
                const updatePickupPointList = (data, scollToTop) => {
                    pickupPointsListEl.innerHTML = data;
                    if (scollToTop)
                        pickupPointsContainer.scrollIntoView({ block: 'nearest' });
                };
                const searchAndUpdatePickuppoints = (zipcode) => {
                    if (zipcode) {
                        return searchPickupPoints(zipcode)
                            .then(res => {
                            if (!res)
                                return;
                            updatePickupPointList(res, true);
                            attachEventAndMarkerForStoreToMap(true);
                        });
                    }
                    else {
                        return $.Deferred().resolve().promise();
                    }
                };
                const searchAndUpdatePickuppointsByCoordinates = (latitude, longitude) => {
                    if (latitude && longitude) {
                        return searchPickupPointsByCoordinates(latitude, longitude, countryInputEl === null || countryInputEl === void 0 ? void 0 : countryInputEl.value)
                            .then(res => {
                            if (!res)
                                return;
                            updatePickupPointList(res, false);
                            attachEventAndMarkerForStoreToMap(false);
                        });
                    }
                    else {
                        return $.Deferred().resolve().promise();
                    }
                };
                const attachEventAndMarkerForStoreToMap = (allowCenterMap) => {
                    if (pickupPointsListEl) {
                        const storesToSelect = eXpress.html.querySelectorAll(pickupPointsListEl, '.technical-select-store');
                        // Center the map on the first store (e.g. the closest)
                        if (allowCenterMap && storesToSelect.length > 0) {
                            const latitude = parseFloat((storesToSelect[0].dataset.lat || "0").replace(",", "."));
                            const longitude = parseFloat((storesToSelect[0].dataset.lng || "0").replace(",", "."));
                            centerMap(latitude, longitude);
                        }
                        storesToSelect
                            .forEach((el) => {
                            const radios = eXpress.html.querySelectorAll(document, '.technical-delivery-time-picker-radio');
                            const arr = radios.filter(f => f.dataset.shipmentpartnername && el.dataset.partnercode && f.dataset.shipmentpartnername.toLowerCase() === el.dataset.partnercode.toLowerCase());
                            if (arr.length) {
                                const shipmentPartner = arr[0];
                                if (shipmentPartner.dataset.showshipmentinfo && JSON.parse(shipmentPartner.dataset.showshipmentinfo)) {
                                    const shipmentPartnerExtraCost = eXpress.html.querySelector(el, '.technical-shipment-extracost');
                                    if (shipmentPartnerExtraCost) {
                                        shipmentPartnerExtraCost.classList.remove("u-hide");
                                        shipmentPartnerExtraCost.innerHTML = shipmentPartner.dataset.shipmentextracost || '';
                                    }
                                    const shipmentPartnerFirstDeliveryDay = eXpress.html.querySelector(el, '.technical-shipment-day');
                                    if (shipmentPartnerFirstDeliveryDay) {
                                        shipmentPartnerFirstDeliveryDay.classList.remove("u-hide");
                                        shipmentPartnerFirstDeliveryDay.innerHTML = shipmentPartner.dataset.shipmentday || '';
                                    }
                                }
                            }
                        });
                        if (!storesToSelect || storesToSelect.length >= 1 || !pickupPointsNoResultsEl) {
                            clearMarkers();
                            storesToSelect.map(el => ({
                                data: convertStoreElement(el),
                                el
                            }))
                                .reverse()
                                .forEach((e) => selectStore(e, storesToSelect.indexOf(e.el)));
                        }
                    }
                };
                const showMarkerInfo = (storeEl, marker) => {
                    if (pickupPointsListEl)
                        eXpress.html.querySelectorAll(pickupPointsListEl, ".m-address-tile--active")
                            .forEach(el => el.classList.remove("m-address-tile--active"));
                    storeEl.classList.add("m-address-tile--active");
                    showMarker(marker);
                };
                const selectStoreAndClose = (store) => {
                    formComponent.validate()
                        .then(x => {
                        if (!x)
                            return;
                        // data should come from form component no reason to query every field
                        const firstNameEl = eXpress.html.querySelector(pickupFormEl, "#FirstName", true);
                        const firstName = firstNameEl.value;
                        const lastNameEl = eXpress.html.querySelector(pickupFormEl, "#LastName", true);
                        const lastName = lastNameEl.value;
                        const zipCodeInputEl = eXpress.html.querySelector(pickupFormEl, "#ZipCode", true);
                        const zipCode = zipCodeInputEl.value;
                        const mobilePhoneEl = eXpress.html.querySelector(pickupFormEl, "#MobileNumber", false);
                        const mobileNumber = mobilePhoneEl && mobilePhoneEl.value;
                        const customerData = {
                            FirstName: firstName,
                            LastName: lastName,
                            PostalCode: zipCode,
                            SendSms: !!mobileNumber,
                            MobileNumber: mobileNumber || '',
                            Address: store.address,
                            PostalCity: store.postalCity,
                            Name: store.name
                        };
                        savePickupPointsAsync(customerData, store.dropoffPointId, store.partnerCode)
                            .then(res => {
                            if (res.Error) {
                                showTopMessage(components.main.PageLogStyle.Error, res.Error);
                            }
                            else {
                                pickupChangeAddress(customerData.Name, `${customerData.FirstName} ${customerData.LastName}, ${customerData.Address}, ${customerData.PostalCity}`, store.forceShipmentMethods, store.phone, store.holiday);
                            }
                        });
                    });
                };
                const selectStore = (store, index) => {
                    const { data, el } = store;
                    const selectButtonEl = eXpress.html.querySelector(el, ".technical-select-button", true);
                    const infoText = `
				<div class="p-pick-up-points__map__info-window">
					<div class="p-pick-up-points__map__address-content">
						<div class="p-pick-up-points__map__delivery-image">
							<img src="${data.partnerLogoUrl}" alt="${data.partnerCode}" />
							${data.is247 ? '<span class="a-icon a-icon--single a-icon--no-fill"><i class="p-pick-up-points__map__icon icon-twenty-four-seven"></i></span> ' : ''}
						</div>
						<div class="p-pick-up-points__map__address-info">
							<div class="p-pick-up-points__map__icon-container">
								<span class="a-icon a-icon--single a-icon--no-fill">
									<i class="p-pick-up-points__map__icon icon-pinpoint"></i>
								</span>
							</div>
							<div class="p-pick-up-points__map__address-container">
								<span class="p-pick-up-points__map__address-name">${data.name}</span>
								<span class="p-pick-up-points__map__address-street">${data.address}</span>
								<span class="p-pick-up-points__map__address-city">${data.postalCity}</span>
							</div>
						</div>
					</div>
					<div class="p-pick-up-points__map__additional-info">
						<span class="p-pick-up-points__map__delivery-costs">${data.shipmentextracost}</span>
						<span class="p-pick-up-points__map__delivery-date">${data.shipmentday}</span>
						<button class='a-button a-button--small p-pick-up-points__map__select-button a-button--close technical-select-button' onclick='document.querySelector(".p-pick-up-points .m-address-tile--active").querySelector(".technical-select-button").click()'>${selectPickUpLabel}</button>
						<div class="p-pick-up-points__map__opening-hours">${data.openingHours}</div>
					</div>
				</div>`;
                    const marker = {
                        Name: data.name,
                        Address: data.address,
                        Latitude: data.lat,
                        Longitude: data.lng,
                        Index: index,
                        Text: infoText,
                        Color: data.partnerColor
                    };
                    createMarker(marker);
                    eXpress.html.addEventListener(el, "click", () => showMarkerInfo(el, marker));
                    eXpress.html.addEventListener(selectButtonEl, 'click', () => selectStoreAndClose(data));
                };
                const convertStoreElement = (storeEl) => {
                    var _a;
                    const openingHours = eXpress.html.querySelector(storeEl, '.technical-openinghours', false);
                    const radios = eXpress.html.querySelectorAll(document, '.technical-delivery-time-picker-radio');
                    const arr = radios.filter(f => f.dataset.shipmentpartnername && storeEl.dataset.partnercode && f.dataset.shipmentpartnername.toLowerCase() === storeEl.dataset.partnercode.toLowerCase());
                    let shipmentday = '';
                    let shipmentextracost = '';
                    if (arr.length) {
                        const shipmentPartner = arr[0];
                        if (shipmentPartner.dataset.showshipmentinfo && JSON.parse(shipmentPartner.dataset.showshipmentinfo)) {
                            const shipmentPartnerExtraCost = eXpress.html.querySelector(storeEl, '.technical-shipment-extracost');
                            if (shipmentPartnerExtraCost) {
                                shipmentPartnerExtraCost.classList.remove("u-hide");
                                shipmentextracost = shipmentPartner.dataset.shipmentextracost || '';
                                shipmentPartnerExtraCost.innerHTML = shipmentPartner.dataset.shipmentextracost || '';
                            }
                            const shipmentPartnerFirstDeliveryDay = eXpress.html.querySelector(storeEl, '.technical-shipment-day');
                            if (shipmentPartnerFirstDeliveryDay) {
                                shipmentPartnerFirstDeliveryDay.classList.remove("u-hide");
                                shipmentday = shipmentPartner.dataset.shipmentday || '';
                                shipmentPartnerFirstDeliveryDay.innerHTML = shipmentPartner.dataset.shipmentday || '';
                            }
                        }
                    }
                    const store = {
                        address: storeEl.dataset.address || "",
                        dropoffPointId: storeEl.dataset.dropoffpoint || "",
                        partnerCode: storeEl.dataset.partnercode || "",
                        partnerColor: storeEl.dataset.partnercolor || "",
                        name: storeEl.dataset.name || "",
                        postalCity: storeEl.dataset.city || "",
                        phone: storeEl.dataset.phone || "",
                        holiday: storeEl.dataset.holiday || "",
                        lat: +(storeEl.dataset.lat || '').replace(",", ".") || 0,
                        lng: +(storeEl.dataset.lng || '').replace(",", ".") || 0,
                        forceShipmentMethods: storeEl.dataset.forceshipmentmethods || '',
                        openingHours: openingHours ? openingHours.innerHTML : '',
                        is247: ((_a = storeEl.dataset.is247) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == 'true' ? true : false,
                        partnerLogoUrl: storeEl.dataset.partnerlogolink || '',
                        shipmentextracost: shipmentextracost,
                        shipmentday: shipmentday
                    };
                    return store;
                };
                const deInit = () => {
                    const countryInputEl = eXpress.html.querySelector(pickupFormEl, "#country_pickuppoints", false);
                    if (countryInputEl)
                        countryInputEl.removeEventListener('change', changeCountry);
                    inputDisposable.dispose();
                    formComponent.dispose();
                };
                const countryInputEl = eXpress.html.querySelector(pickupFormEl, "#country_pickuppoints", false);
                if (countryInputEl)
                    countryInputEl.addEventListener('change', changeCountry);
                const inputDisposable = eXpress.utils.compositeDisposable([
                    components.main.createTextInputWithAutoComplete(cityInputEl, {
                        autoCompleteSearch: (term) => getCitiesForCountryCodeAndSearchTerm(term, selectedCountry)
                            .then(res => res.map(x => ({ value: x.zipcode, label: x.name }))),
                        onSelect: (item) => {
                            if (item.value) {
                                cityInputEl.dataset.ZipCode = item.value;
                                zipCodeInputEl.value = item.value;
                                formComponent.validate()
                                    .then(x => {
                                    if (!x)
                                        return;
                                    return searchAndUpdatePickuppoints(item.value);
                                    ;
                                });
                            }
                        },
                        preventSubmit: true
                    }), eXpress.html.addEventListener(zipCodeInputEl, 'change', () => {
                        preselectedZipCode = zipCodeInputEl.value;
                        cityInputEl.value = '';
                    })
                ]);
                if (countryInputEl && countryInputEl.options) {
                    const selectedOption = countryInputEl.options[countryInputEl.selectedIndex] || countryInputEl.options[0];
                    selectedCountry = countryInputEl.value;
                    // we load view in dialog, and if there is a country select,
                    // we do another ajax call for pickupoints again, why not load this on page load?
                    changeCountryForPickups(selectedCountry, selectedOption.getAttribute("data-searchtype") || undefined, countryInputEl.options[countryInputEl.selectedIndex].getAttribute("selected") || undefined);
                }
                else {
                    attachEventAndMarkerForStoreToMap(true);
                }
                return {
                    dispose: deInit,
                    centerChanged: searchAndUpdatePickuppointsByCoordinates
                };
            }
            checkout.createPickupDelivery = createPickupDelivery;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createPlaceOrder(containerEl, deps) {
                const submitButtonEl = eXpress.html.querySelector(containerEl, ".technical-place-order-submit", false);
                const requiredCheckBoxes = eXpress.html.querySelectorAll(containerEl, ".a-form-input__input[required]");
                const adyenDropInContainerEl = eXpress.html.querySelector(containerEl, "#dropin-container", false);
                const paymentOptionsContainerEl = eXpress.html.querySelector(containerEl, '.technical-paymentoptions', true);
                const newsletterEl = eXpress.html.querySelector(containerEl, ".technical-newsletter", true);
                const personalMessageEl = eXpress.html.querySelector(containerEl, ".technical-personal-message", true);
                const testOrderOptionEl = eXpress.html.querySelector(containerEl, ".technical-testorderoption", false);
                let newsletter = false;
                let personalMessage = false;
                let dropIns;
                const requiredFormInputs = [];
                const eventDisposables = eXpress.utils.compositeDisposable([]);
                const { placeOrder, placeOfflineOrder, getPaymentMethods, initiatePayment, submitAdditionalDetails, updateCartHandlingCost, disableStoredPaymentMethod } = deps;
                const recaptchaEnabled = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.recaptchaenabled === "true" || false;
                const useEnterprise = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.recaptchaenterpriseenabled === "true";
                const fetchRecaptchaToken = () => {
                    return new Promise((resolve, _) => {
                        const siteKey = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.sitekey || "";
                        const key = paymentOptionsContainerEl && paymentOptionsContainerEl.dataset.key || "";
                        if (useEnterprise) {
                            grecaptcha.enterprise.execute(key, { action: 'cart_payment' })
                                .then((token) => {
                                resolve(token);
                            });
                        }
                        else {
                            grecaptcha.execute(siteKey, { action: 'cart_payment' })
                                .then((token) => {
                                resolve(token);
                            });
                        }
                    });
                };
                const onSubmit = (e) => {
                    e.preventDefault();
                    newsletter = newsletterEl.checked;
                    personalMessage = personalMessageEl.checked;
                    if (validate()) {
                        if (recaptchaEnabled)
                            fetchRecaptchaToken().then(token => { placeOrder(newsletter, personalMessage, token, getTestOrderOptionValue(testOrderOptionEl)); });
                        else
                            placeOrder(newsletter, personalMessage, "", getTestOrderOptionValue(testOrderOptionEl));
                    }
                };
                const getTestOrderOptionValue = (container) => {
                    var _a;
                    if (!container)
                        return undefined;
                    const radios = eXpress.html.querySelectorAll(container, "[name=TestOrderOption]");
                    return (_a = radios.find(x => x.checked)) === null || _a === void 0 ? void 0 : _a.value;
                };
                const validate = () => {
                    let isValid = true;
                    let scrollToEl = null;
                    if (requiredFormInputs && requiredFormInputs.length > 0) {
                        requiredFormInputs.forEach(el => {
                            const parent = el.inputEl.parentElement;
                            const errorParagraphEl = eXpress.html.querySelector(parent, ".a-form-input__error-text", true);
                            if (!el.inputEl.checked) {
                                if (!scrollToEl)
                                    scrollToEl = el.inputEl;
                                el.setError(errorParagraphEl.innerHTML);
                                if (eventDisposables && eventDisposables.add) {
                                    eventDisposables.add([
                                        eXpress.html.addEventListener(el.inputEl, 'change', () => { el.clear(false); })
                                    ]);
                                }
                                if (isValid)
                                    isValid = false;
                            }
                        });
                    }
                    if (scrollToEl) {
                        scrollToEl = scrollToEl;
                        scrollToEl.scrollIntoView();
                    }
                    if (isValid)
                        requiredFormInputs.forEach(el => el.disable());
                    return isValid;
                };
                const addHandlers = () => {
                    if (submitButtonEl && eventDisposables && eventDisposables.add) {
                        eventDisposables.add([
                            eXpress.html.addEventListener(submitButtonEl, 'click', onSubmit)
                        ]);
                    }
                };
                const init = () => {
                    newsletter = newsletterEl.checked;
                    personalMessage = personalMessageEl.checked;
                    if (recaptchaEnabled) {
                        if (useEnterprise) {
                            grecaptcha.enterprise.ready(() => {
                                addHandlers();
                            });
                        }
                        else {
                            grecaptcha.ready(() => {
                                addHandlers();
                            });
                        }
                    }
                    else {
                        addHandlers();
                    }
                    if (requiredCheckBoxes && requiredCheckBoxes.length > 0) {
                        requiredCheckBoxes.forEach(el => {
                            const parentContainer = eXpress.html.getParentWithClassName(el, "a-form-input");
                            if (parentContainer) {
                                const input = eXpress.components.main.createFormInput(parentContainer);
                                requiredFormInputs.push(input);
                            }
                        });
                    }
                    if (adyenDropInContainerEl) {
                        const createAdyenDropInElement = () => __awaiter(this, void 0, void 0, function* () {
                            dropIns = yield checkout.createAdyenDropIn(adyenDropInContainerEl, {
                                getPaymentMethods,
                                validate,
                                initiatePayment,
                                disableStoredPaymentMethod,
                                submitAdditionalDetails,
                                placeOfflineOrder,
                                newsletterEl,
                                personalMessageEl,
                                testOrderOptionEl,
                                updateCartHandlingCost,
                                getTestOrderOptionValue,
                                fetchRecaptchaToken,
                                recaptchaEnabled
                            });
                        });
                        if (recaptchaEnabled) {
                            if (useEnterprise) {
                                grecaptcha.enterprise.ready(() => {
                                    createAdyenDropInElement();
                                });
                            }
                            else {
                                grecaptcha.ready(() => {
                                    createAdyenDropInElement();
                                });
                            }
                        }
                        else {
                            createAdyenDropInElement();
                        }
                    }
                };
                init();
                return {
                    resetAdyenDropIn: () => dropIns && dropIns.reset(),
                    dispose: () => { eventDisposables && eventDisposables.dispose(); dropIns && dropIns.dispose(); },
                };
            }
            checkout.createPlaceOrder = createPlaceOrder;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createCartProductTiles(cartContainerEl, cartProductTilesEl, deps) {
                const { refreshMiniBasket, deleteCartProduct, changeQuantity, refreshDiscount, refreshContinueButton } = deps;
                const optionCollapsablesEls = eXpress.html.querySelectorAll(cartProductTilesEl, ".technical-cart-options");
                let cartUpdateTimer;
                const deleteClick = (el) => {
                    const productTile = eXpress.html.getParentWithClassName(el, "technical-cart-1product");
                    if (productTile) {
                        const id = productTile.dataset.cartitemid;
                        const productname = productTile.dataset.productname;
                        const quantityInput = eXpress.html.querySelector(productTile, '.technical-cart-quantity', true);
                        const origCurrentQuantity = parseInt(quantityInput.value, 10) || 0;
                        let currentQuantity = parseInt(quantityInput.value, 10) || 0;
                        if (id) {
                            // Special case for the delete, if we are deleting the last additional
                            const isAdditional = productTile.dataset.isadditional === 'true';
                            if (!isAdditional) {
                                // Am I the last non-additional and there are additional ? Eek -> warn the user
                                const allProductTiles = eXpress.html.querySelectorAll(cartProductTilesEl, ".technical-cart-1product");
                                let additional = 0;
                                let nonAdditionl = 0;
                                allProductTiles.forEach(p => {
                                    const isAdditional = p.dataset.isadditional === 'true';
                                    if (isAdditional) {
                                        additional++;
                                        const productName = p.dataset.productname;
                                        if (productName) {
                                            const productQuantityInput = eXpress.html.querySelector(p, '.technical-cart-quantity', true);
                                            const productQuantity = parseInt(productQuantityInput.value, 10) || 0;
                                            currentQuantity += productQuantity;
                                        }
                                    }
                                    else
                                        nonAdditionl++;
                                });
                                if (additional == 0 || nonAdditionl > 1) {
                                    currentQuantity = origCurrentQuantity;
                                }
                            }
                            deleteCartProduct(id, (res) => {
                                handleGtm(currentQuantity, 0, productTile.dataset.gtmdata);
                                refreshBadgeTotal(-currentQuantity);
                                if (refreshMiniBasket)
                                    refreshMiniBasket(res.NewMiniBasketHtml);
                                if (refreshDiscount)
                                    refreshDiscount(res.NewDiscountHtml);
                                if (refreshContinueButton)
                                    refreshContinueButton(res.NewContinueButtonHtml);
                                productTile.remove();
                                if (res.EmptyBasketHtml) {
                                    cartContainerEl.innerHTML = res.EmptyBasketHtml;
                                }
                                else if (res.NewProductHtmls) {
                                    res.NewProductHtmls.forEach(p => {
                                        const changeTile = eXpress.html.querySelector(cartContainerEl, '.technical-cart-1product[data-cartitemid="' + p.CartItemId + '"]', true);
                                        recreateProductTile(changeTile, p.NewProductHtml);
                                    });
                                }
                            }, productname);
                        }
                    }
                };
                const minusClick = (el) => {
                    minusPlusClick(el, -1);
                };
                const plusClick = (el) => {
                    minusPlusClick(el, 1);
                };
                const minusPlusClick = (button, change) => {
                    var _a;
                    const productTile = eXpress.html.getParentWithClassName(button, "technical-cart-1product");
                    if (!productTile)
                        return;
                    const id = productTile.dataset.cartitemid;
                    if (!id)
                        return;
                    const quantityInput = eXpress.html.querySelector(productTile, '.technical-cart-quantity', true);
                    const lowerQtyBound = /*parseInt(quantityInput.dataset.min || '1', 10) ||*/ 1;
                    const upperQtyBound = parseInt(quantityInput.dataset.max || '999', 10) || 999;
                    const oldQuantity = parseInt(productTile.dataset.quantity || '0', 10);
                    let currentQuantity = parseInt(quantityInput.value, 10) || 0;
                    currentQuantity += change;
                    let outOfBounds = false;
                    if (currentQuantity < lowerQtyBound) {
                        outOfBounds = true;
                        currentQuantity = lowerQtyBound;
                    }
                    if (currentQuantity > upperQtyBound) {
                        outOfBounds = true;
                        currentQuantity = upperQtyBound;
                    }
                    if (outOfBounds)
                        return;
                    /* Disable/enable - button ? */
                    if (currentQuantity == 1)
                        button.classList.add('a-button--disabled');
                    else if (button.parentElement)
                        (_a = eXpress.html.querySelector(button.parentElement, '.technical-cart-minus', false)) === null || _a === void 0 ? void 0 : _a.classList.remove('a-button--disabled');
                    refreshBadgeTotal(change);
                    quantityInput.value = currentQuantity.toString();
                    if (cartUpdateTimer) {
                        window.clearTimeout(cartUpdateTimer);
                    }
                    cartUpdateTimer = window.setTimeout(() => {
                        handleGtm(oldQuantity, currentQuantity, productTile.dataset.gtmdata);
                        changeQuantity(id, currentQuantity).then(res => {
                            if (refreshMiniBasket)
                                refreshMiniBasket(res.NewMiniBasketHtml);
                            if (refreshDiscount)
                                refreshDiscount(res.NewDiscountHtml);
                            if (res.NewProductHtmls) {
                                res.NewProductHtmls.forEach(p => {
                                    const changeTile = eXpress.html.querySelector(cartContainerEl, '.technical-cart-1product[data-cartitemid="' + p.CartItemId + '"]', true);
                                    recreateProductTile(changeTile, p.NewProductHtml);
                                });
                            }
                        });
                    }, 500);
                };
                const handleGtm = (oldQuanity, newQuantity, gtmData) => {
                    if (!gtmData)
                        return;
                    const gtmObject = JSON.parse(gtmData);
                    const changeQuantity = Math.abs(oldQuanity - newQuantity);
                    // Change the quantity & the event
                    const product = gtmObject.ecommerce.add.products[0];
                    const productUnitPrice = product.price / product.quantity;
                    product.quantity = changeQuantity;
                    product.priceWOVat = +(product.priceWOVat / oldQuanity * changeQuantity).toFixed(2);
                    product.price = +(productUnitPrice * product.quantity).toFixed(2);
                    if (oldQuanity > newQuantity) {
                        gtmObject.event = 'eec.remove';
                        gtmObject.ecommerce.remove = gtmObject.ecommerce.add;
                        delete gtmObject.ecommerce.add;
                    }
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(gtmObject);
                };
                const recreateProductTile = (productTile, newHTML) => {
                    let reOpenOptions = false;
                    let reFocusQuantity = false;
                    // briefly check if the option collapse is opened
                    const oldOptionCollapse = eXpress.html.querySelector(productTile, ".technical-cart-options");
                    if (oldOptionCollapse && oldOptionCollapse.classList.contains("is-collapse-open"))
                        reOpenOptions = true;
                    // Briefly check the old inpout cursor pos
                    const oldInput = eXpress.html.querySelector(productTile, '.technical-cart-quantity');
                    if (oldInput === document.activeElement)
                        reFocusQuantity = true;
                    const oldSameDesignsSlider = eXpress.html.querySelector(productTile, '.technical-samedesignsslider-container');
                    const cursorPos = oldInput ? eXpress.utils.doGetCaretPosition(oldInput) : 0;
                    const node = eXpress.html.htmlToElement(newHTML);
                    if (node) {
                        productTile.replaceWith(node);
                        // Put the slider back
                        oldSameDesignsSlider && node.append(oldSameDesignsSlider);
                    }
                    // re-init the collapsable for the newly received HTML
                    const optionCollapse = eXpress.html.querySelector(node, ".technical-cart-options");
                    if (optionCollapse) {
                        const opt = components.main.createCollapsable(optionCollapse, { titleElSelector: '.technical-collapsable-title', scrollIntoViewAfterOpen: true });
                        if (reOpenOptions)
                            opt.open();
                    }
                    // Re-focus the quantity box
                    if (reFocusQuantity) {
                        const newInput = eXpress.html.querySelector(node, '.technical-cart-quantity');
                        if (newInput) {
                            newInput.focus();
                            eXpress.utils.setCaretPosition(newInput, cursorPos);
                        }
                    }
                };
                const fixQuantity = (inputEl) => {
                    const regex = new RegExp("[^0-9]", 'g');
                    const intValue = parseInt(inputEl.value, 10);
                    const lowerQtyBound = /*parseInt(inputEl.dataset.min || '1', 10) || */ 1;
                    const upperQtyBound = parseInt(inputEl.dataset.max || '999', 10) || 999;
                    if (inputEl.value.match(regex) || isNaN(intValue) || intValue > upperQtyBound || intValue < lowerQtyBound) {
                        const productTile = eXpress.html.getParentWithClassName(inputEl, "technical-cart-1product");
                        if (!productTile)
                            return;
                        const oldQuantity = productTile.dataset.quantity;
                        if (oldQuantity)
                            inputEl.value = oldQuantity;
                    }
                };
                const updateQuantity = (inputEl) => {
                    const productTile = eXpress.html.getParentWithClassName(inputEl, "technical-cart-1product");
                    if (!productTile)
                        return;
                    const id = productTile.dataset.cartitemid;
                    if (!id)
                        return;
                    if (cartUpdateTimer) {
                        window.clearTimeout(cartUpdateTimer);
                    }
                    const oldQuantity = parseInt(productTile.dataset.quantity || '0', 10);
                    const currentQuantity = parseInt(inputEl.value, 10) || 0;
                    const lowerQtyBound = /*parseInt(inputEl.dataset.min || '1', 10) || */ 1;
                    const upperQtyBound = parseInt(inputEl.dataset.max || '999', 10) || 999;
                    if (currentQuantity < lowerQtyBound)
                        return;
                    if (currentQuantity > upperQtyBound)
                        return;
                    if (oldQuantity === currentQuantity)
                        return;
                    cartUpdateTimer = window.setTimeout(() => {
                        handleGtm(oldQuantity, currentQuantity, productTile.dataset.gtmdata);
                        changeQuantity(id, currentQuantity).then(res => {
                            refreshBadgeTotal(-oldQuantity + currentQuantity);
                            if (refreshMiniBasket)
                                refreshMiniBasket(res.NewMiniBasketHtml);
                            if (res.NewProductHtmls) {
                                res.NewProductHtmls.forEach(p => {
                                    const changeTile = eXpress.html.querySelector(cartContainerEl, '.technical-cart-1product[data-cartitemid="' + p.CartItemId + '"]', true);
                                    recreateProductTile(changeTile, p.NewProductHtml);
                                });
                            }
                        });
                    }, 500);
                };
                const refreshBadgeTotal = (addToBadge) => {
                    const changeBadgeQty = eXpress.html.querySelector(document, '.technical-basket-itemcount', false);
                    if (changeBadgeQty) {
                        const currentBadgeTotal = parseInt(changeBadgeQty.innerText, 10) || 0;
                        const newQuantity = currentBadgeTotal + addToBadge;
                        changeBadgeQty.innerHTML = (newQuantity < 0 ? 0 : newQuantity).toString();
                    }
                };
                const previewClick = (ev, el) => {
                    ev.preventDefault();
                    const productTile = eXpress.html.getParentWithClassName(el, "technical-cart-1product");
                    if (!productTile)
                        return;
                    let editLink = '';
                    const editIcon = eXpress.html.querySelector(productTile, ".icon-pencil", false);
                    if (editIcon && editIcon.parentElement) {
                        const parentEl = editIcon.parentElement;
                        editLink = parentEl.href;
                    }
                    deps.previewPopup(productTile.dataset.cartitemid || '', editLink);
                };
                const clickDispatcher = (event) => {
                    const clickedElement = event.target;
                    if (!clickedElement)
                        return;
                    // The delete icons
                    if (clickedElement.classList.contains('technical-cart-delete'))
                        deleteClick(clickedElement);
                    // The minus icons
                    if (clickedElement.classList.contains('technical-cart-minus'))
                        minusClick(clickedElement);
                    // The plus icons
                    if (clickedElement.classList.contains('technical-cart-plus'))
                        plusClick(clickedElement);
                    // The preview
                    if (clickedElement.parentElement && clickedElement.parentElement.classList.contains('technical-preview') || clickedElement.classList.contains('technical-preview'))
                        previewClick(event, clickedElement);
                };
                const keyDispatcher = (event) => {
                    const currentElement = event.target;
                    if (!currentElement)
                        return;
                    const lowerQtyBound = /*parseInt(currentElement.dataset.min || '1', 10) || */ 1;
                    const upperQtyBound = parseInt(currentElement.dataset.max || '999', 10) || 999;
                    // The quantity inputs
                    if (currentElement.classList.contains('technical-cart-quantity')) {
                        if (event.type === 'keypress')
                            eXpress.utils.isValidNumberAfterKeyPress(event, lowerQtyBound, upperQtyBound);
                        else if (event.type === 'input')
                            updateQuantity(currentElement);
                        else if (event.type === 'focusout')
                            fixQuantity(currentElement);
                    }
                };
                const init = () => {
                    const queryCartItemId = eXpress.utils.getParameter('addedItemId', window.location.href, false);
                    if (queryCartItemId) {
                        const allProductTiles = eXpress.html.querySelectorAll(cartProductTilesEl, ".technical-cart-1product");
                        allProductTiles.forEach(p => {
                            const cartItemId = p.dataset.cartitemid;
                            if (cartItemId && queryCartItemId === cartItemId) {
                                const stringGtmData = p.dataset.gtmdata;
                                if (stringGtmData) {
                                    const gtm = JSON.parse(stringGtmData);
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push(gtm);
                                }
                            }
                        });
                    }
                    optionCollapsablesEls.forEach(el => {
                        components.main.createCollapsable(el, { scrollIntoViewAfterOpen: true, titleElSelector: '.technical-collapsable-title' });
                    });
                };
                const eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(cartProductTilesEl, 'click', clickDispatcher),
                    eXpress.html.addEventListener(cartProductTilesEl, 'keypress', keyDispatcher),
                    eXpress.html.addEventListener(cartProductTilesEl, 'input', keyDispatcher),
                    eXpress.html.addEventListener(cartProductTilesEl, 'focusout', keyDispatcher)
                ]);
                init();
                return {
                    dispose: () => {
                        eventDisposables.dispose();
                    }
                };
            }
            checkout.createCartProductTiles = createCartProductTiles;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createRemoveConfirmation(containerEl, deps) {
                const { onRemoveConfirm } = deps;
                const yesButton = components.main.createButton(eXpress.html.querySelector(containerEl, '.technical-remove-confirmation-yes-button', true), () => onRemoveConfirm(true));
                const noButton = components.main.createButton(eXpress.html.querySelector(containerEl, '.technical-remove-confirmation-no-button', true), () => onRemoveConfirm(false));
                return {
                    dispose: () => {
                        yesButton.dispose();
                        noButton.dispose();
                    }
                };
            }
            checkout.createRemoveConfirmation = createRemoveConfirmation;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createSlideIn(containerEl, deps) {
                const { onInit, onClose } = deps;
                const closeBtnEl = eXpress.html.querySelector(containerEl, ".technical-close", true);
                const onCloseEvent = () => {
                    const hideDays = parseInt(containerEl.dataset.hidedays || "30", 10);
                    containerEl.classList.add("u-hide");
                    if (onClose)
                        onClose();
                    eXpress.utils.writeCookie("showRecSlideIn", "false", hideDays);
                    closeEvent.dispose();
                    containerEl.remove();
                    eXpress.analytics.trackRecommendationCartEvent("Slide-in slider closed");
                };
                const closeEvent = eXpress.html.addEventListener(closeBtnEl, 'click', onCloseEvent);
                if (onInit)
                    onInit();
                return { dispose: closeEvent.dispose };
            }
            checkout.createSlideIn = createSlideIn;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var checkout;
        (function (checkout) {
            function createTrailDialog(dialog, deps) {
                const { statuses, title, delivery, shipping, error } = deps;
                const statusContainer = eXpress.html.querySelector(dialog, '.technical-trail-container', true);
                // Title is always there
                const titleEl = eXpress.html.querySelector(dialog, '.technical-trail-title', true);
                titleEl.innerHTML = title;
                // Delivery is optional
                const deliveryEl = eXpress.html.querySelector(dialog, '.technical-trail-delivery', true);
                if (delivery && !error) {
                    deliveryEl.innerHTML = deps.delivery;
                    deliveryEl.classList.remove("u-hide");
                }
                else
                    deliveryEl.classList.add("u-hide");
                // Delivery is optional
                const shippingEl = eXpress.html.querySelector(dialog, '.technical-trail-shipping', true);
                if (shipping && !error) {
                    shippingEl.innerHTML = deps.shipping;
                    shippingEl.classList.remove("u-hide");
                    const ttLinks = eXpress.html.querySelectorAll(shippingEl, ".technical-tracktrace");
                    ttLinks.forEach(link => link.addEventListener('click', (ev) => {
                        eXpress.analytics.trackOrderStatusEvent("TrailDialogTrackTraceClick", { orderNumber: deps.orderNumber, orderStatus: deps.currentStatus, pvc: deps.pvc });
                    }));
                    const voucherLinks = eXpress.html.querySelectorAll(shippingEl, ".technical-voucher");
                    voucherLinks.forEach(link => link.addEventListener('click', (ev) => {
                        eXpress.analytics.trackOrderStatusEvent("TrailDialogVoucherDownload", { orderNumber: deps.orderNumber, orderStatus: deps.currentStatus, pvc: deps.pvc });
                    }));
                }
                else
                    shippingEl.classList.add("u-hide");
                // Error is true => something went wrong in the request to the ecom api
                if (error) {
                    const errorEl = eXpress.html.querySelector(statusContainer, '.technical-trail-error', true);
                    errorEl.classList.remove("u-hide");
                }
                else {
                    // Fill in the statuses: title, description & active
                    const statusTemplate = eXpress.html.querySelector(statusContainer, '.technical-trail-template', true);
                    // Clear the container of all previous statuses
                    eXpress.html.querySelectorAll(statusContainer, '.technical-trail-block')
                        .forEach(block => statusContainer.removeChild(block));
                    const lastActiveIndex = statuses.reduce((acc, status, index) => (status.active ? index : acc), -1);
                    let index = 0;
                    // For each status, add a HTML block
                    statuses.forEach(status => {
                        const statusClone = statusTemplate.cloneNode(true);
                        statusClone.classList.remove('technical-trail-template');
                        statusClone.classList.remove('u-hide');
                        statusClone.classList.add('technical-trail-block');
                        statusClone.dataset.name = status.name;
                        eXpress.html.querySelector(statusClone, '.technical-trail-status', true).innerHTML = status.status;
                        eXpress.html.querySelector(statusClone, '.technical-trail-description', true).innerHTML = status.description;
                        if (!status.active)
                            statusClone.classList.remove('m-trail__element--completed');
                        if (lastActiveIndex === index)
                            statusClone.classList.add('m-trail__element--last-completed');
                        statusContainer.appendChild(statusClone);
                        index++;
                    });
                }
                return {};
            }
            checkout.createTrailDialog = createTrailDialog;
        })(checkout = components.checkout || (components.checkout = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
